// @ts-strict-ignore
import {
    AmplitudeIntegrationData,
    AndroidVitalsIntegrationData,
    ApplePowerPerformanceIntegrationData,
    AppPlatform,
    AppSettings,
    AppStoreType,
    CustomAnalyticsIntegrationData,
    DatadogAnalyticsIntegrationData,
    Environment,
    EventAndParam,
    GoogleAnalyticsIntegrationData,
    Integration,
    IntegrationCapability,
    IntegrationErrorType,
    IntegrationInstallationId,
    IntegrationProvider,
    IntegrationProviderAppCenter,
    IntegrationProviderApple,
    IntegrationProviderType,
    IntegrationType,
    MixpanelAnalyticsIntegrationData,
    NewRelicAnalyticsIntegrationData,
    WorkflowArgument,
    WorkflowType,
} from './../types';
import {
    defaultAppStoreTypeForPlatform,
    defaultStoreIntegrationForPlatform,
    eventNameFromEventAndParam,
    getIsApplePlatform,
    isGooglePlatform,
    makeEventAndParam,
    sanitizeTrackName,
} from './../helpers';
import {
    CreateIntegrationRequest,
    RefreshIntegrationRequest,
    UpdateIntegrationRequestDataType,
} from '../actions/integrations';
import { StepGraphStep } from '../types/workflow';
import {
    AuthUpdatable,
    IntegrationDeletable,
    IntegrationRefreshable,
    IntegrationUpdatable,
} from '../actions/updatable';
import qs from 'query-string';
import {
    ASANA_APP_INSTALLATION_BASE_URL,
    ASANA_CLIENT_ID_DEV,
    ASANA_CLIENT_ID_PROD,
    AZURE_AD_APP_INSTALLATION_BASE_URL,
    AZURE_AD_CLIENT_ID_DEV,
    AZURE_AD_CLIENT_ID_PROD,
    AZURE_AD_TENANT_ID,
    AZURE_APP_INSTALLATION_BASE_URL,
    AZURE_CLIENT_ID_DEV,
    AZURE_CLIENT_ID_PROD,
    BITBUCKET_AUTHORIZE_BASE_URL,
    BITBUCKET_OAUTH_CLIENT_ID,
    BITBUCKET_OAUTH_CLIENT_ID_DEV,
    GITHUB_APP_INSTALLATION_BASE_URL_DEV,
    GITHUB_APP_INSTALLATION_BASE_URL_PROD,
    GITLAB_AUTHORIZE_BASE_URL,
    GITLAB_CLIENT_ID_DEV,
    GITLAB_CLIENT_ID_PROD,
    GOOGLE_OAUTH_APP_INSTALLATION_BASE_URL,
    GOOGLE_OAUTH_CLIENT_ID,
    GOOGLE_PLAY_CLIENT_ID_DEV,
    GOOGLE_PLAY_CLIENT_ID_PROD,
    integrationAuthRedirectUri,
    JIRA_APP_INSTALLATION_BASE_URL,
    JIRA_CLIENT_ID_DEV,
    JIRA_CLIENT_ID_PROD,
    LINEAR_APP_INSTALLATION_BASE_URL,
    LINEAR_CLIENT_ID_DEV,
    LINEAR_CLIENT_ID_PROD,
    MONDAY_APP_INSTALLATION_BASE_URL,
    MONDAY_CLIENT_ID_DEV,
    MONDAY_CLIENT_ID_PROD,
    SLACK_AUTHORIZE_BASE_URL,
    SLACK_CLIENT_ID_DEV,
    SLACK_CLIENT_ID_PROD,
    postinstallRedirectUri,
    TEST_ORG_IDS,
} from '../constants';
import appStoreLogo from '../../assets/integration-apple-app-store.svg';
import githubLogo from '../../assets/integration-github.svg';
import gitLabLogo from '../../assets/integration-gitlab.svg';
import slackLogo from '../../assets/integration-slack.svg';
import codemagicLogo from '../../assets/integration-codemagic.svg';
import bitriseLogo from '../../assets/integration-bitrise.svg';
import buildkiteLogo from '../../assets/integration-buildkite.svg';
import jiraLogo from '../../assets/integration-jira.svg';
import pivotalLogo from '../../assets/integration-pivotal.svg';
import jenkinsLogo from '../../assets/integration-jenkins.svg';
import circleLogo from '../../assets/integration-circleci.svg';
import googlePlayLogo from '../../assets/integration-play.svg';
import amazonLogo from '../../assets/integration-amazonappstore.svg';
import linearLogo from '../../assets/integration-linear.svg';
import bugsnagLogo from '../../assets/integration-bugsnag.svg';
import sentryLogo from '../../assets/integration-sentry.svg';
import testRailLogo from '../../assets/integration-testrail.svg';
import browserStackLogo from '../../assets/integration-browserstack.svg';
import qaseLogo from '../../assets/integration-qase.svg';
import testflightLogo from '../../assets/integration-testflight.png';
import travisCILogo from '../../assets/integration-travisci.svg';
import firebaseCrashlyticsLogo from '../../assets/integration-firebase-crashlytics.svg';
import firebaseAppDistributionLogo from '../../assets/integration-firebase-app-distribution.svg';
import xrayLogo from '../../assets/integration-xray.svg';
import appcenterCILogo from '../../assets/integration-appcenter.svg';
import asanaLogo from '../../assets/integration-asana.svg';
import shortcutLogo from '../../assets/integration-shortcut.svg';
import amplitudeLogo from '../../assets/integration-amplitude.svg';
import bitbucketLogo from '../../assets/integration-bitbucket.svg';
import azureLogo from '../../assets/integration-azure-devops.svg';
import azureBoardsLogo from '../../assets/integration-azure-boards.svg';
import azurePipelinesLogo from '../../assets/integration-azure-pipelines.svg';
import azureReposLogo from '../../assets/integration-azure-repos.svg';
import jiraServiceManagementLogo from '../../assets/integration-jira-service-management.svg';
import gaLogo from '../../assets/integration-google-analytics.svg';
import avLogo from '../../assets/integration-android-vitals.svg';
import datadogLogo from '../../assets/integration-datadog.svg';
import dynatraceLogo from '../../assets/integration-dynatrace.svg';
import mixpanelLogo from '../../assets/integration-mixpanel.svg';
import optimizelyLogo from '../../assets/integration-optimizely.svg';
import launchDarklyLogo from '../../assets/integration-launchdarkly.svg';
import statsigLogo from '../../assets/integration-statsig.svg';
import genericCILogo from '../../assets/integration-generic-ci.svg';
import xcodeCloudLogo from '../../assets/integration-xcode-cloud.svg';
import mondayLogo from '../../assets/integration-mondaycom.svg';
import embraceLogo from '../../assets/integration-embrace.svg';
import runwayLogo from '../../assets/integration-runway.svg';
import microsoftTeamsLogo from '../../assets/integration-microsoft-teams.svg';
import crowdinLogo from '../../assets/integration-crowdin.svg';
import pagerDutyLogo from '../../assets/integration-pagerduty.svg';
import newRelicLogo from '../../assets/integration-new-relic.svg';
import opsgenieLogo from '../../assets/integration-opsgenie.svg';
import rootlyLogo from '../../assets/integration-rootly.svg';
import incidentIoLogo from '../../assets/integration-incident-io.svg';
import huaweiAppGalleryLogo from '../../assets/integration-huawei-appgallery.svg';
import lokaliseLogo from '../../assets/integration-lokalise.svg';
import smartlingLogo from '../../assets/integration-smartling.svg';
import samsungLogo from '../../assets/integration-samsung.svg';
import googleCalendar from '../../assets/google-calendar.svg';
import applePowerPerformanceMetricsLogo from '../../assets/integration-apple-power-and-performance-metrics.svg';
import customIntegrationLogo from '../../assets/integration-custom.svg';

import { isEmpty } from 'lodash';

export interface IntegrationCreateOrRefreshRequestOrError {
    authType?: AuthUpdatable;
    integrationRefreshable?: IntegrationRefreshable;
    createRequest?: CreateIntegrationRequest;
    refreshRequest?: RefreshIntegrationRequest;
    error?: string;
}

export const extractIntegrationRequestFromRedirect: (
    integrationString: string,
    queryParameters: qs.ParsedQuery,
    orgId: string,
    appId: string,
    orgIdParam: string,
    appIdParam: string,
) => IntegrationCreateOrRefreshRequestOrError = (
    integrationString,
    queryParameters,
    orgId,
    appId,
    orgIdParam,
    appIdParam,
) => {
    switch (integrationString) {
        // vanilla oauth integrations
        case IntegrationType.Slack:
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitLabCI:
        case IntegrationType.Jira:
        case IntegrationType.JiraServiceManagementScheduling:
        case IntegrationType.Linear:
        case IntegrationType.Asana:
        case IntegrationType.Bitbucket:
        case IntegrationType.BitbucketCI:
        case IntegrationType.AzureCI:
        case IntegrationType.AzureIT:
        case IntegrationType.AzureVCS:
        case IntegrationType.Monday:
        case IntegrationType.MicrosoftTeams:
        case IntegrationType.GooglePersonalCalendar:
            return parseIntegrationRequestAuthRedirect(
                queryParameters,
                orgIdParam,
                appIdParam,
                integrationString as IntegrationType,
            );
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubIT:
            return parseGitHubInstallationRedirect(integrationString, queryParameters, orgId, appId);
        default:
            return {
                error: 'Unrecognized integration type. Please try again.',
            };
    }
};

const parseGitHubInstallationRedirect: (
    integrationType: IntegrationType,
    queryParams: qs.ParsedQuery,
    orgId: string,
    appId: string,
) => IntegrationCreateOrRefreshRequestOrError = (integrationType, queryParams, orgId, appId) => {
    if (queryParams.error) {
        return {
            error: queryParams.error as string, // No idea if gh actually returns an error
        };
    }

    if (queryParams.installationId && queryParams.setupAction) {
        const authType = authTypeForIntegrationType(integrationType);
        const integrationRefreshable = integrationRefreshableForIntegrationType(integrationType);

        const githubInstallationId = queryParams.installationId as string;
        const setupAction = queryParams.setupAction as string;
        const integrationInstallationId = queryParams.integrationInstallationId as string;

        let createRequest: CreateIntegrationRequest;
        let refreshRequest: RefreshIntegrationRequest;
        if (isEmpty(integrationInstallationId)) {
            createRequest = {
                integrationId: integrationType,
                orgId,
                appId,
                data: {
                    installationId: githubInstallationId,
                    setupAction,
                },
            };
        } else {
            refreshRequest = {
                integrationId: integrationInstallationId,
                appId,
                orgId,
            };
        }

        return {
            authType,
            integrationRefreshable: integrationRefreshable,
            createRequest: createRequest,
            refreshRequest: refreshRequest,
        };
    } else {
        return {
            error: 'Something went wrong, please try again.',
        };
    }
};

const parseIntegrationRequestAuthRedirect: (
    queryParams: qs.ParsedQuery,
    orgId: string,
    appId: string,
    integrationType: IntegrationType,
) => IntegrationCreateOrRefreshRequestOrError = (queryParams, orgId, appId, integrationType) => {
    if (queryParams.error) {
        return {
            error: 'Authorization denied.',
        };
    }

    if (queryParams.code) {
        const accessCode = queryParams.code as string;
        const existingProviderId = queryParams.existingProviderId as string;
        const authType = authTypeForIntegrationType(integrationType);

        var forceDev = false;
        // Special handling mostly for Slack Marketplace review
        if (integrationType == IntegrationType.Slack && TEST_ORG_IDS.includes(orgId)) {
            forceDev = true;
        }

        const redirectUri = postinstallRedirectUri(integrationType, forceDev);

        const request: CreateIntegrationRequest = {
            integrationId: integrationType,
            orgId,
            appId,
            data: {
                oAuthAuthorizationCode: accessCode,
                redirectUri: redirectUri,
                providerId: existingProviderId,
                reauth: queryParams.reauth === 'true',
            },
        };

        return {
            authType,
            createRequest: request,
        };
    } else {
        // Redirect was triggered, but auth code isn't present

        return {
            error: 'Something went wrong, please try again.',
        };
    }
};

export const oauthInstallationUrlForIntegrationType: (
    integrationType: IntegrationType,
    orgId: string,
    orgIdParam: string,
    appIdParam: string,
    shouldRedirectToSamePage?: boolean,
    integrationInstallationId?: IntegrationInstallationId,
) => string = (integrationType, orgId, orgIdParam, appIdParam, shouldRedirectToSamePage, integrationInstallationId) => {
    const environment = process.env.NODE_ENV as Environment;

    const redirectURL =
        shouldRedirectToSamePage ?
            window.location.origin + window.location.pathname
        :   integrationAuthRedirectUri(orgIdParam, appIdParam, integrationType);

    const state = {
        redirectURI: redirectURL,
        orgId: orgId,
        integrationId: integrationType,
        ...(integrationInstallationId && { integrationInstallationId }),
    };

    const installBaseUrl = installBaseUrlForIntegrationType(integrationType, environment);

    switch (integrationType) {
        case IntegrationType.Slack: {
            var clientId = environment === Environment.Development ? SLACK_CLIENT_ID_DEV : SLACK_CLIENT_ID_PROD;
            var forceDev = false;
            var scopes =
                'app_mentions:read,bookmarks:write,channels:join,channels:manage,channels:read,chat:write,chat:write.public,commands,groups:read,groups:write,im:read,im:write,im:history,reactions:read,reactions:write,usergroups:read,usergroups:write,users:read,users:read.email';

            // Special handling mostly for Slack Marketplace review
            if (TEST_ORG_IDS.includes(orgId)) {
                clientId = SLACK_CLIENT_ID_DEV;
                forceDev = true;

                // Add new scopes here if needed, before Slack app updates are approved in Marketplace
                //scopes += '';
            }

            const queryParams = {
                scope: scopes,
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.Slack, forceDev),
                state: JSON.stringify(state),
            };
            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubIT: {
            const queryParams = {
                state: JSON.stringify(state),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitLabCI: {
            const clientId = environment === Environment.Development ? GITLAB_CLIENT_ID_DEV : GITLAB_CLIENT_ID_PROD;
            const queryParams = {
                scope: 'api',
                response_type: 'code',
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(integrationType),
                state: JSON.stringify(state),
            };
            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.Jira: {
            const clientId = environment === Environment.Development ? JIRA_CLIENT_ID_DEV : JIRA_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                scope: 'write:jira-work read:jira-work manage:jira-project read:jira-user offline_access',
                audience: 'api.atlassian.com',
                response_type: 'code',
                prompt: 'consent',
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.Jira),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.JiraServiceManagementScheduling: {
            const clientId = environment === Environment.Development ? JIRA_CLIENT_ID_DEV : JIRA_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                scope: 'read:ops-config:jira-service-management read:user:jira offline_access read:ops-alert:jira-service-management write:ops-alert:jira-service-management',
                audience: 'api.atlassian.com',
                response_type: 'code',
                prompt: 'consent',
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.Jira), // Jira also for JSM, we will discriminate via state.IntegrationId (type)
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        // NOT IN USE
        case IntegrationType.Google: {
            const clientId =
                environment === Environment.Development ? GOOGLE_PLAY_CLIENT_ID_DEV : GOOGLE_PLAY_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                scope: 'https://www.googleapis.com/auth/androidpublisher',
                response_type: 'code',
                client_id: clientId,
                access_type: 'offline',
                redirect_uri: postinstallRedirectUri(IntegrationType.Google),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.Linear: {
            const clientId = environment === Environment.Development ? LINEAR_CLIENT_ID_DEV : LINEAR_CLIENT_ID_PROD;
            var scope = 'read,write';
            const disallowAdminScopeForOrgs = [
                'org_Euqitd7t', // OpenAI
            ];
            if (!disallowAdminScopeForOrgs.includes(orgId)) {
                scope += ',admin'; // Admin scope is needed for Linear label creation
            }
            const queryParams = {
                state: JSON.stringify(state),
                response_type: 'code',
                client_id: clientId,
                scope: scope,
                access_type: 'offline',
                redirect_uri: postinstallRedirectUri(IntegrationType.Linear),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.Asana: {
            const clientId = environment === Environment.Development ? ASANA_CLIENT_ID_DEV : ASANA_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                response_type: 'code',
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.Asana),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.Bitbucket:
        case IntegrationType.BitbucketCI: {
            const clientId =
                environment === Environment.Development ? BITBUCKET_OAUTH_CLIENT_ID_DEV : BITBUCKET_OAUTH_CLIENT_ID;
            const queryParams = {
                response_type: 'code',
                client_id: clientId,
                state: JSON.stringify(state),
                // scopes and redirect are defined when making client ID and secret in Bitbucket
                redirect_uri: postinstallRedirectUri(IntegrationType.Bitbucket),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.AzureCI:
        case IntegrationType.AzureIT:
        case IntegrationType.AzureVCS: {
            const clientId = environment === Environment.Development ? AZURE_CLIENT_ID_DEV : AZURE_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                response_type: 'Assertion',
                client_id: clientId,
                scope: 'vso.build_execute vso.identity vso.notification_manage vso.project vso.release_manage vso.work_full vso.code_full',
                redirect_uri: postinstallRedirectUri(IntegrationType.AzureCI),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.Monday: {
            const clientId = environment === Environment.Development ? MONDAY_CLIENT_ID_DEV : MONDAY_CLIENT_ID_PROD;
            const queryParams = {
                state: JSON.stringify(state),
                response_type: 'code',
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.Monday),
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.MicrosoftTeams: {
            const clientId = environment === Environment.Development ? AZURE_AD_CLIENT_ID_DEV : AZURE_AD_CLIENT_ID_PROD;
            const tenantId = AZURE_AD_TENANT_ID;
            const queryParams = {
                client_id: clientId,
                redirect_uri: postinstallRedirectUri(IntegrationType.MicrosoftTeams),
                response_mode: 'query',
                response_type: 'code',
                scope: 'channelmessage.send groupmember.read.all channel.readbasic.all channel.create team.readbasic.all user.read.all user.read channel.delete.all chat.create chatmessage.send teammember.read.all openid offline_access profile teamworktag.read teamworktag.readwrite group.readwrite.all',
                state: JSON.stringify(state),
                tenant: tenantId,
            };

            const encodedParams = qs.stringify(queryParams);

            return `${installBaseUrl}?${encodedParams}`;
        }
        case IntegrationType.GooglePersonalCalendar: {
            const queryParams = {
                access_type: 'offline',
                prompt: 'consent',
                client_id: GOOGLE_OAUTH_CLIENT_ID,
                redirect_uri: postinstallRedirectUri(IntegrationType.GooglePersonalCalendar),
                response_type: 'code',
                scope: 'https://www.googleapis.com/auth/calendar',
                state: JSON.stringify(state),
            };

            const encodedParams = qs.stringify(queryParams);
            return `${installBaseUrl}?${encodedParams}`;
        }
        default:
            return null;
    }
};

export const installBaseUrlForIntegrationType: (
    integrationType: IntegrationType,
    environment: Environment,
) => string = (integrationType, environment) => {
    switch (integrationType) {
        case IntegrationType.Slack: {
            return SLACK_AUTHORIZE_BASE_URL;
        }
        case IntegrationType.Bitbucket:
        case IntegrationType.BitbucketCI: {
            return BITBUCKET_AUTHORIZE_BASE_URL;
        }
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitLabCI: {
            return GITLAB_AUTHORIZE_BASE_URL;
        }
        case IntegrationType.GitHubCIDistribution:
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubIT: {
            return environment === Environment.Development ?
                    GITHUB_APP_INSTALLATION_BASE_URL_DEV
                :   GITHUB_APP_INSTALLATION_BASE_URL_PROD;
        }
        case IntegrationType.Jira:
        case IntegrationType.JiraServiceManagementScheduling: {
            // TODO: replace dev url with actual dev url

            return environment === Environment.Development ?
                    JIRA_APP_INSTALLATION_BASE_URL
                :   JIRA_APP_INSTALLATION_BASE_URL;
        }
        case IntegrationType.Linear:
            return LINEAR_APP_INSTALLATION_BASE_URL;
        case IntegrationType.Asana:
            return ASANA_APP_INSTALLATION_BASE_URL;
        case IntegrationType.AzureCI:
        case IntegrationType.AzureIT:
        case IntegrationType.AzureVCS: {
            return AZURE_APP_INSTALLATION_BASE_URL;
        }
        case IntegrationType.Monday: {
            return MONDAY_APP_INSTALLATION_BASE_URL;
        }
        case IntegrationType.MicrosoftTeams: {
            return AZURE_AD_APP_INSTALLATION_BASE_URL;
        }
        case IntegrationType.GooglePersonalCalendar:
            return GOOGLE_OAUTH_APP_INSTALLATION_BASE_URL;
        default:
            return null;
    }
};

export const authTypeForIntegrationType: (integrationType: IntegrationType) => AuthUpdatable = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.Apple:
            return AuthUpdatable.AppStoreConnectAccess;
        case IntegrationType.GitHubVCS:
            return AuthUpdatable.GitHubVCSAccess;
        case IntegrationType.GitHubCI:
            return AuthUpdatable.GitHubCIAccess;
        case IntegrationType.GitHubIT:
            return AuthUpdatable.GitHubITAccess;
        case IntegrationType.GitHubVCSDistribution:
            return AuthUpdatable.GitHubVCSDistAccess;
        case IntegrationType.GitHubCIDistribution:
            return AuthUpdatable.GitHubCIDistAccess;
        case IntegrationType.Jira:
            return AuthUpdatable.JiraAccess;
        case IntegrationType.Pivotal:
            return AuthUpdatable.PivotalAccess;
        case IntegrationType.Shortcut:
            return AuthUpdatable.ShortcutAccess;
        case IntegrationType.Slack:
            return AuthUpdatable.SlackAccess;
        case IntegrationType.GitLabVCS:
            return AuthUpdatable.GitLabVCSAccess;
        case IntegrationType.GitLabCI:
            return AuthUpdatable.GitLabCIAccess;
        case IntegrationType.Codemagic:
            return AuthUpdatable.CodemagicAccess;
        case IntegrationType.Bitrise:
            return AuthUpdatable.BitriseAccess;
        case IntegrationType.Buildkite:
            return AuthUpdatable.BuildkiteAccess;
        case IntegrationType.Bugsnag:
            return AuthUpdatable.BugsnagAccess;
        case IntegrationType.Sentry:
            return AuthUpdatable.SentryAccess;
        case IntegrationType.Jenkins:
            return AuthUpdatable.JenkinsAccess;
        case IntegrationType.CircleCI:
            return AuthUpdatable.CircleAccess;
        case IntegrationType.Amazon:
            return AuthUpdatable.AmazonAppStoreAccess;
        case IntegrationType.Google:
            return AuthUpdatable.GooglePlayAccess;
        case IntegrationType.GoogleBeta:
            return AuthUpdatable.GoogleBetaAccess;
        case IntegrationType.Linear:
            return AuthUpdatable.LinearAccess;
        case IntegrationType.TestFlight:
            return AuthUpdatable.TestFlightAccess;
        case IntegrationType.TestRail:
            return AuthUpdatable.TestRailAccess;
        case IntegrationType.BrowserStack:
            return AuthUpdatable.BrowserStackAccess;
        case IntegrationType.Qase:
            return AuthUpdatable.QaseAccess;
        case IntegrationType.TravisCI:
            return AuthUpdatable.TravisCIAccess;
        case IntegrationType.Firebase:
            return AuthUpdatable.FirebaseAccess;
        case IntegrationType.GoogleAnalytics:
            return AuthUpdatable.GoogleAnalyticsAccess;
        case IntegrationType.AndroidVitals:
            return AuthUpdatable.AndroidVitalsAccess;
        case IntegrationType.ApplePowerPerformanceMetrics:
            return AuthUpdatable.ApplePowerPerformanceAccess;
        case IntegrationType.Xray:
            return AuthUpdatable.XrayAccess;
        case IntegrationType.AppCenterCI:
            return AuthUpdatable.AppCenterCIAccess;
        case IntegrationType.AppCenterBeta:
            return AuthUpdatable.AppCenterBetaAccess;
        case IntegrationType.Asana:
            return AuthUpdatable.AsanaAccess;
        case IntegrationType.Amplitude:
            return AuthUpdatable.AmplitudeAccess;
        case IntegrationType.Bitbucket:
            return AuthUpdatable.BitbucketAccess;
        case IntegrationType.BitbucketCI:
            return AuthUpdatable.BitbucketCIAccess;
        case IntegrationType.AzureCI:
            return AuthUpdatable.AzureCIAccess;
        case IntegrationType.AzureIT:
            return AuthUpdatable.AzureITAccess;
        case IntegrationType.Optimizely:
            return AuthUpdatable.OptimizelyAccess;
        case IntegrationType.LaunchDarkly:
            return AuthUpdatable.LaunchDarklyAccess;
        case IntegrationType.Statsig:
            return AuthUpdatable.StatsigAccess;
        case IntegrationType.DatadogAnalytics:
            return AuthUpdatable.DatadogAnalyticsAccess;
        case IntegrationType.GenericCI:
            return AuthUpdatable.GenericCIAccess;
        case IntegrationType.CustomCI:
            return AuthUpdatable.CustomCIAccess;
        case IntegrationType.MixpanelAnalytics:
            return AuthUpdatable.MixpanelAnalyticsAccess;
        case IntegrationType.XcodeCloud:
            return AuthUpdatable.XcodeCloudAccess;
        case IntegrationType.Monday:
            return AuthUpdatable.MondayAccess;
        case IntegrationType.FirebaseBeta:
            return AuthUpdatable.FirebaseBetaAccess;
        case IntegrationType.RunwayBuildDistroBeta:
            return AuthUpdatable.RunwayBuildDistroBetaAccess;
        case IntegrationType.EmbraceStabilityMonitoring:
            return AuthUpdatable.EmbraceStabilityMonitoringAccess;
        case IntegrationType.AzureVCS:
            return AuthUpdatable.AzureVCSAccess;
        case IntegrationType.MicrosoftTeams:
            return AuthUpdatable.MicrosoftTeamsAccess;
        case IntegrationType.DatadogStabilityMonitoring:
            return AuthUpdatable.DatadogStabilityMonitoringAccess;
        case IntegrationType.Crowdin:
            return AuthUpdatable.CrowdinAccess;
        case IntegrationType.PagerDutyScheduling:
            return AuthUpdatable.PagerDutyAccess;
        case IntegrationType.NewRelicStabilityMonitoring:
            return AuthUpdatable.NewRelicStabilityMonitoringAccess;
        case IntegrationType.NewRelicAnalytics:
            return AuthUpdatable.NewRelicAnalyticsAccess;
        case IntegrationType.HuaweiAppGallery:
            return AuthUpdatable.HuaweiAppGalleryAccess;
        case IntegrationType.Lokalise:
            return AuthUpdatable.LokaliseAccess;
        case IntegrationType.Samsung:
            return AuthUpdatable.SamsungAccess;
        case IntegrationType.OpsgenieScheduling:
            return AuthUpdatable.OpsgenieAccess;
        case IntegrationType.DynatraceStabilityMonitoring:
            return AuthUpdatable.DynatraceAccess;
        case IntegrationType.CustomAnalytics:
            return AuthUpdatable.CustomAnalyticsAccess;
        case IntegrationType.GoogleCalendar:
            return AuthUpdatable.GoogleCalendarAccess;
        case IntegrationType.GooglePersonalCalendar:
            return AuthUpdatable.GooglePersonalCalendarAccess;
        case IntegrationType.JiraServiceManagementScheduling:
            return AuthUpdatable.JiraServiceManagementAccess;
        case IntegrationType.RootlyScheduling:
            return AuthUpdatable.RootlyAccess;
        case IntegrationType.IncidentIoScheduling:
            return AuthUpdatable.IncidentIoAccess;
        default:
            return null;
    }
};

export const integrationUpdatableForIntegrationType: (integrationType: IntegrationType) => IntegrationUpdatable = (
    integrationType: IntegrationType,
) => {
    switch (integrationType) {
        case IntegrationType.Apple:
            return IntegrationUpdatable.AppleAppStore;
        case IntegrationType.GitHubVCS:
            return IntegrationUpdatable.GitHubVCS;
        case IntegrationType.GitHubCI:
            return IntegrationUpdatable.GitHubCI;
        case IntegrationType.GitHubIT:
            return IntegrationUpdatable.GitHubIT;
        case IntegrationType.GitHubVCSDistribution:
            return IntegrationUpdatable.GitHubVCSDist;
        case IntegrationType.GitHubCIDistribution:
            return IntegrationUpdatable.GitHubCIDist;
        case IntegrationType.GitLabVCS:
            return IntegrationUpdatable.GitLabVCS;
        case IntegrationType.GitLabCI:
            return IntegrationUpdatable.GitLabCI;
        case IntegrationType.Jira:
            return IntegrationUpdatable.Jira;
        case IntegrationType.Pivotal:
            return IntegrationUpdatable.Pivotal;
        case IntegrationType.Shortcut:
            return IntegrationUpdatable.Shortcut;
        case IntegrationType.Slack:
            return IntegrationUpdatable.Slack;
        case IntegrationType.Codemagic:
            return IntegrationUpdatable.Codemagic;
        case IntegrationType.Bitrise:
            return IntegrationUpdatable.Bitrise;
        case IntegrationType.Buildkite:
            return IntegrationUpdatable.Buildkite;
        case IntegrationType.Bugsnag:
            return IntegrationUpdatable.Bugsnag;
        case IntegrationType.Sentry:
            return IntegrationUpdatable.Sentry;
        case IntegrationType.Jenkins:
            return IntegrationUpdatable.Jenkins;
        case IntegrationType.CircleCI:
            return IntegrationUpdatable.Circle;
        case IntegrationType.Amazon:
            return IntegrationUpdatable.Amazon;
        case IntegrationType.Google:
            return IntegrationUpdatable.Google;
        case IntegrationType.GoogleBeta:
            return IntegrationUpdatable.GoogleBeta;
        case IntegrationType.Linear:
            return IntegrationUpdatable.Linear;
        case IntegrationType.TestFlight:
            return IntegrationUpdatable.TestFlight;
        case IntegrationType.TestRail:
            return IntegrationUpdatable.TestRail;
        case IntegrationType.BrowserStack:
            return IntegrationUpdatable.BrowserStack;
        case IntegrationType.Qase:
            return IntegrationUpdatable.Qase;
        case IntegrationType.TravisCI:
            return IntegrationUpdatable.TravisCI;
        case IntegrationType.Firebase:
            return IntegrationUpdatable.Firebase;
        case IntegrationType.GoogleAnalytics:
            return IntegrationUpdatable.GoogleAnalytics;
        case IntegrationType.AndroidVitals:
            return IntegrationUpdatable.AndroidVitals;
        case IntegrationType.ApplePowerPerformanceMetrics:
            return IntegrationUpdatable.ApplePowerPerformance;
        case IntegrationType.Xray:
            return IntegrationUpdatable.Xray;
        case IntegrationType.AppCenterCI:
            return IntegrationUpdatable.AppCenterCI;
        case IntegrationType.AppCenterBeta:
            return IntegrationUpdatable.AppCenterBeta;
        case IntegrationType.Asana:
            return IntegrationUpdatable.Asana;
        case IntegrationType.Amplitude:
            return IntegrationUpdatable.Amplitude;
        case IntegrationType.Bitbucket:
            return IntegrationUpdatable.Bitbucket;
        case IntegrationType.BitbucketCI:
            return IntegrationUpdatable.BitbucketCI;
        case IntegrationType.AzureCI:
            return IntegrationUpdatable.AzureCI;
        case IntegrationType.AzureIT:
            return IntegrationUpdatable.AzureIT;
        case IntegrationType.Optimizely:
            return IntegrationUpdatable.Optimizely;
        case IntegrationType.LaunchDarkly:
            return IntegrationUpdatable.LaunchDarkly;
        case IntegrationType.Statsig:
            return IntegrationUpdatable.Statsig;
        case IntegrationType.DatadogAnalytics:
            return IntegrationUpdatable.DatadogAnalytics;
        case IntegrationType.GenericCI:
            return IntegrationUpdatable.GenericCI;
        case IntegrationType.CustomCI:
            return IntegrationUpdatable.CustomCI;
        case IntegrationType.MixpanelAnalytics:
            return IntegrationUpdatable.MixpanelAnalytics;
        case IntegrationType.XcodeCloud:
            return IntegrationUpdatable.XcodeCloud;
        case IntegrationType.Monday:
            return IntegrationUpdatable.Monday;
        case IntegrationType.FirebaseBeta:
            return IntegrationUpdatable.FirebaseBeta;
        case IntegrationType.RunwayBuildDistroBeta:
            return IntegrationUpdatable.RunwayBuildDistroBeta;
        case IntegrationType.EmbraceStabilityMonitoring:
            return IntegrationUpdatable.EmbraceStabilityMonitoring;
        case IntegrationType.AzureVCS:
            return IntegrationUpdatable.AzureVCS;
        case IntegrationType.MicrosoftTeams:
            return IntegrationUpdatable.MicrosoftTeams;
        case IntegrationType.DatadogStabilityMonitoring:
            return IntegrationUpdatable.DatadogStabilityMonitoring;
        case IntegrationType.Crowdin:
            return IntegrationUpdatable.Crowdin;
        case IntegrationType.PagerDutyScheduling:
            return IntegrationUpdatable.PagerDutyScheduling;
        case IntegrationType.NewRelicStabilityMonitoring:
            return IntegrationUpdatable.NewRelicStabilityMonitoring;
        case IntegrationType.NewRelicAnalytics:
            return IntegrationUpdatable.NewRelicAnalytics;
        case IntegrationType.HuaweiAppGallery:
            return IntegrationUpdatable.HuaweiAppGallery;
        case IntegrationType.Lokalise:
            return IntegrationUpdatable.Lokalise;
        case IntegrationType.Samsung:
            return IntegrationUpdatable.Samsung;
        case IntegrationType.OpsgenieScheduling:
            return IntegrationUpdatable.OpsgenieScheduling;
        case IntegrationType.DynatraceStabilityMonitoring:
            return IntegrationUpdatable.Dynatrace;
        case IntegrationType.CustomAnalytics:
            return IntegrationUpdatable.CustomAnalytics;
        case IntegrationType.GoogleCalendar:
            return IntegrationUpdatable.GoogleCalendar;
        case IntegrationType.GooglePersonalCalendar:
            return IntegrationUpdatable.GooglePersonalCalendar;
        case IntegrationType.JiraServiceManagementScheduling:
            return IntegrationUpdatable.JiraServiceManagement;
        case IntegrationType.RootlyScheduling:
            return IntegrationUpdatable.RootlyScheduling;
        case IntegrationType.IncidentIoScheduling:
            return IntegrationUpdatable.IncidentIoScheduling;
        default:
            return null;
    }
};

export const integrationRefreshableForIntegrationType: (
    integrationType: IntegrationType,
) => IntegrationRefreshable | null = (integrationType: IntegrationType) => {
    switch (integrationType) {
        case IntegrationType.Apple:
            return IntegrationRefreshable.AppleAppStore;
        case IntegrationType.GitHubVCS:
            return IntegrationRefreshable.GitHubVCS;
        case IntegrationType.GitHubCI:
            return IntegrationRefreshable.GitHubCI;
        case IntegrationType.GitHubIT:
            return IntegrationRefreshable.GitHubIT;
        case IntegrationType.GitHubVCSDistribution:
            return IntegrationRefreshable.GitHubVCSDist;
        case IntegrationType.GitHubCIDistribution:
            return IntegrationRefreshable.GitHubCIDist;
        case IntegrationType.GitLabVCS:
            return IntegrationRefreshable.GitLabVCS;
        case IntegrationType.GitLabCI:
            return IntegrationRefreshable.GitLabCI;
        case IntegrationType.Jira:
            return IntegrationRefreshable.Jira;
        case IntegrationType.Pivotal:
            return IntegrationRefreshable.Pivotal;
        case IntegrationType.Shortcut:
            return IntegrationRefreshable.Shortcut;
        case IntegrationType.Slack:
            return IntegrationRefreshable.Slack;
        case IntegrationType.Codemagic:
            return IntegrationRefreshable.Codemagic;
        case IntegrationType.Bitrise:
            return IntegrationRefreshable.Bitrise;
        case IntegrationType.Buildkite:
            return IntegrationRefreshable.Buildkite;
        case IntegrationType.Bugsnag:
            return IntegrationRefreshable.Bugsnag;
        case IntegrationType.Sentry:
            return IntegrationRefreshable.Sentry;
        case IntegrationType.Jenkins:
            return IntegrationRefreshable.Jenkins;
        case IntegrationType.CircleCI:
            return IntegrationRefreshable.Circle;
        case IntegrationType.Amazon:
            return IntegrationRefreshable.Amazon;
        case IntegrationType.Google:
            return IntegrationRefreshable.Google;
        case IntegrationType.GoogleBeta:
            return IntegrationRefreshable.GoogleBeta;
        case IntegrationType.Linear:
            return IntegrationRefreshable.Linear;
        case IntegrationType.TestFlight:
            return IntegrationRefreshable.TestFlight;
        case IntegrationType.TestRail:
            return IntegrationRefreshable.TestRail;
        case IntegrationType.BrowserStack:
            return IntegrationRefreshable.BrowserStack;
        case IntegrationType.Qase:
            return IntegrationRefreshable.Qase;
        case IntegrationType.TravisCI:
            return IntegrationRefreshable.TravisCI;
        case IntegrationType.Firebase:
            return IntegrationRefreshable.Firebase;
        case IntegrationType.GoogleAnalytics:
            return IntegrationRefreshable.GoogleAnalytics;
        case IntegrationType.Xray:
            return IntegrationRefreshable.Xray;
        case IntegrationType.AppCenterCI:
            return IntegrationRefreshable.AppCenterCI;
        case IntegrationType.AppCenterBeta:
            return IntegrationRefreshable.AppCenterBeta;
        case IntegrationType.Asana:
            return IntegrationRefreshable.Asana;
        case IntegrationType.Amplitude:
            return IntegrationRefreshable.Amplitude;
        case IntegrationType.Bitbucket:
            return IntegrationRefreshable.Bitbucket;
        case IntegrationType.BitbucketCI:
            return IntegrationRefreshable.BitbucketCI;
        case IntegrationType.AzureCI:
            return IntegrationRefreshable.AzureCI;
        case IntegrationType.AzureIT:
            return IntegrationRefreshable.AzureIT;
        case IntegrationType.Optimizely:
            return IntegrationRefreshable.Optimizely;
        case IntegrationType.LaunchDarkly:
            return IntegrationRefreshable.LaunchDarkly;
        case IntegrationType.Statsig:
            return IntegrationRefreshable.Statsig;
        case IntegrationType.DatadogAnalytics:
            return IntegrationRefreshable.DatadogAnalytics;
        case IntegrationType.GenericCI:
            return IntegrationRefreshable.GenericCI;
        case IntegrationType.CustomCI:
            return IntegrationRefreshable.CustomCI;
        case IntegrationType.MixpanelAnalytics:
            return IntegrationRefreshable.MixpanelAnalytics;
        case IntegrationType.XcodeCloud:
            return IntegrationRefreshable.XcodeCloud;
        case IntegrationType.Monday:
            return IntegrationRefreshable.Monday;
        case IntegrationType.FirebaseBeta:
            return IntegrationRefreshable.FirebaseBeta;
        case IntegrationType.RunwayBuildDistroBeta:
            return IntegrationRefreshable.RunwayBuildDistroBeta;
        case IntegrationType.EmbraceStabilityMonitoring:
            return IntegrationRefreshable.EmbraceStabilityMonitoring;
        case IntegrationType.AzureVCS:
            return IntegrationRefreshable.AzureVCS;
        case IntegrationType.MicrosoftTeams:
            return IntegrationRefreshable.MicrosoftTeams;
        case IntegrationType.DatadogStabilityMonitoring:
            return IntegrationRefreshable.DatadogStabilityMonitoring;
        case IntegrationType.Crowdin:
            return IntegrationRefreshable.Crowdin;
        case IntegrationType.PagerDutyScheduling:
            return IntegrationRefreshable.PagerDutyScheduling;
        case IntegrationType.NewRelicStabilityMonitoring:
            return IntegrationRefreshable.NewRelicStabilityMonitoring;
        case IntegrationType.NewRelicAnalytics:
            return IntegrationRefreshable.NewRelicAnalytics;
        case IntegrationType.HuaweiAppGallery:
            return IntegrationRefreshable.HuaweiAppGallery;
        case IntegrationType.Lokalise:
            return IntegrationRefreshable.Lokalise;
        case IntegrationType.Samsung:
            return IntegrationRefreshable.Samsung;
        case IntegrationType.OpsgenieScheduling:
            return IntegrationRefreshable.OpsgenieScheduling;
        case IntegrationType.DynatraceStabilityMonitoring:
            return IntegrationRefreshable.Dynatrace;
        case IntegrationType.CustomAnalytics:
            return IntegrationRefreshable.CustomAnalytics;
        case IntegrationType.JiraServiceManagementScheduling:
            return IntegrationRefreshable.JiraServiceManagement;
        case IntegrationType.RootlyScheduling:
            return IntegrationRefreshable.RootlyScheduling;
        case IntegrationType.IncidentIoScheduling:
            return IntegrationRefreshable.IncidentIoScheduling;
        default:
            return null;
    }
};

export const integrationDeletableForIntegrationType: (integrationType: IntegrationType) => IntegrationDeletable = (
    integrationType,
) => {
    switch (integrationType) {
        case IntegrationType.Apple:
            return IntegrationDeletable.AppleAppStore;
        case IntegrationType.GitHubVCS:
            return IntegrationDeletable.GitHubVCS;
        case IntegrationType.GitHubCI:
            return IntegrationDeletable.GitHubCI;
        case IntegrationType.GitHubIT:
            return IntegrationDeletable.GitHubIT;
        case IntegrationType.GitHubVCSDistribution:
            return IntegrationDeletable.GitHubVCSDist;
        case IntegrationType.GitHubCIDistribution:
            return IntegrationDeletable.GitHubCIDist;
        case IntegrationType.GitLabVCS:
            return IntegrationDeletable.GitLabVCS;
        case IntegrationType.GitLabCI:
            return IntegrationDeletable.GitLabCI;
        case IntegrationType.Jira:
            return IntegrationDeletable.Jira;
        case IntegrationType.Pivotal:
            return IntegrationDeletable.Pivotal;
        case IntegrationType.Shortcut:
            return IntegrationDeletable.Shortcut;
        case IntegrationType.Slack:
            return IntegrationDeletable.Slack;
        case IntegrationType.Codemagic:
            return IntegrationDeletable.Codemagic;
        case IntegrationType.Bitrise:
            return IntegrationDeletable.Bitrise;
        case IntegrationType.Buildkite:
            return IntegrationDeletable.Buildkite;
        case IntegrationType.Bugsnag:
            return IntegrationDeletable.Bugsnag;
        case IntegrationType.Sentry:
            return IntegrationDeletable.Sentry;
        case IntegrationType.Jenkins:
            return IntegrationDeletable.Jenkins;
        case IntegrationType.CircleCI:
            return IntegrationDeletable.Circle;
        case IntegrationType.Amazon:
            return IntegrationDeletable.Amazon;
        case IntegrationType.Google:
            return IntegrationDeletable.Google;
        case IntegrationType.GoogleBeta:
            return IntegrationDeletable.GoogleBeta;
        case IntegrationType.Linear:
            return IntegrationDeletable.Linear;
        case IntegrationType.TestFlight:
            return IntegrationDeletable.TestFlight;
        case IntegrationType.TestRail:
            return IntegrationDeletable.TestRail;
        case IntegrationType.BrowserStack:
            return IntegrationDeletable.BrowserStack;
        case IntegrationType.Qase:
            return IntegrationDeletable.Qase;
        case IntegrationType.TravisCI:
            return IntegrationDeletable.TravisCI;
        case IntegrationType.Firebase:
            return IntegrationDeletable.Firebase;
        case IntegrationType.GoogleAnalytics:
            return IntegrationDeletable.GoogleAnalytics;
        case IntegrationType.AndroidVitals:
            return IntegrationDeletable.AndroidVitals;
        case IntegrationType.ApplePowerPerformanceMetrics:
            return IntegrationDeletable.ApplePowerPerformance;
        case IntegrationType.Xray:
            return IntegrationDeletable.Xray;
        case IntegrationType.AppCenterCI:
            return IntegrationDeletable.AppCenterCI;
        case IntegrationType.AppCenterBeta:
            return IntegrationDeletable.AppCenterBeta;
        case IntegrationType.Asana:
            return IntegrationDeletable.Asana;
        case IntegrationType.Amplitude:
            return IntegrationDeletable.Amplitude;
        case IntegrationType.Bitbucket:
            return IntegrationDeletable.Bitbucket;
        case IntegrationType.BitbucketCI:
            return IntegrationDeletable.BitbucketCI;
        case IntegrationType.AzureCI:
            return IntegrationDeletable.AzureCI;
        case IntegrationType.AzureIT:
            return IntegrationDeletable.AzureIT;
        case IntegrationType.Optimizely:
            return IntegrationDeletable.Optimizely;
        case IntegrationType.LaunchDarkly:
            return IntegrationDeletable.LaunchDarkly;
        case IntegrationType.Statsig:
            return IntegrationDeletable.Statsig;
        case IntegrationType.DatadogAnalytics:
            return IntegrationDeletable.DatadogAnalytics;
        case IntegrationType.GenericCI:
            return IntegrationDeletable.GenericCI;
        case IntegrationType.CustomCI:
            return IntegrationDeletable.CustomCI;
        case IntegrationType.MixpanelAnalytics:
            return IntegrationDeletable.MixpanelAnalytics;
        case IntegrationType.XcodeCloud:
            return IntegrationDeletable.XcodeCloud;
        case IntegrationType.Monday:
            return IntegrationDeletable.Monday;
        case IntegrationType.FirebaseBeta:
            return IntegrationDeletable.FirebaseBeta;
        case IntegrationType.RunwayBuildDistroBeta:
            return IntegrationDeletable.RunwayBuildDistroBeta;
        case IntegrationType.EmbraceStabilityMonitoring:
            return IntegrationDeletable.EmbraceStabilityMonitoring;
        case IntegrationType.AzureVCS:
            return IntegrationDeletable.AzureVCS;
        case IntegrationType.MicrosoftTeams:
            return IntegrationDeletable.MicrosoftTeams;
        case IntegrationType.DatadogStabilityMonitoring:
            return IntegrationDeletable.DatadogStabilityMonitoring;
        case IntegrationType.Crowdin:
            return IntegrationDeletable.Crowdin;
        case IntegrationType.PagerDutyScheduling:
            return IntegrationDeletable.PagerDutyScheduling;
        case IntegrationType.NewRelicStabilityMonitoring:
            return IntegrationDeletable.NewRelicStabilityMonitoring;
        case IntegrationType.NewRelicAnalytics:
            return IntegrationDeletable.NewRelicAnalytics;
        case IntegrationType.HuaweiAppGallery:
            return IntegrationDeletable.HuaweiAppGallery;
        case IntegrationType.Lokalise:
            return IntegrationDeletable.Lokalise;
        case IntegrationType.Samsung:
            return IntegrationDeletable.Samsung;
        case IntegrationType.OpsgenieScheduling:
            return IntegrationDeletable.OpsgenieScheduling;
        case IntegrationType.DynatraceStabilityMonitoring:
            return IntegrationDeletable.Dynatrace;
        case IntegrationType.CustomAnalytics:
            return IntegrationDeletable.CustomAnalytics;
        case IntegrationType.GoogleCalendar:
            return IntegrationDeletable.GoogleCalendar;
        case IntegrationType.GooglePersonalCalendar:
            return IntegrationDeletable.GooglePersonalCalendar;
        case IntegrationType.JiraServiceManagementScheduling:
            return IntegrationDeletable.JiraServiceManagement;
        case IntegrationType.RootlyScheduling:
            return IntegrationDeletable.RootlyScheduling;
        case IntegrationType.IncidentIoScheduling:
            return IntegrationDeletable.IncidentIoScheduling;
        default:
            return null;
    }
};

export const displayNameForIntegrationType: (integrationType: IntegrationType) => string = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.Apple:
            return 'App Store';
        case IntegrationType.Bitbucket:
            return 'Bitbucket';
        case IntegrationType.BitbucketCI:
            return 'Bitbucket Pipelines';
        case IntegrationType.GitHubVCS:
            return 'GitHub';
        case IntegrationType.GitHubCI:
            return 'GitHub Actions';
        case IntegrationType.GitHubIT:
            return 'GitHub Issues';
        case IntegrationType.GitLabVCS:
            return 'GitLab';
        case IntegrationType.GitLabCI:
            return 'GitLab CI';
        case IntegrationType.Jira:
            return 'Jira';
        case IntegrationType.Pivotal:
            return 'Pivotal Tracker';
        case IntegrationType.Shortcut:
            return 'Shortcut';
        case IntegrationType.Slack:
            return 'Slack';
        case IntegrationType.Codemagic:
            return 'Codemagic';
        case IntegrationType.Bitrise:
            return 'Bitrise';
        case IntegrationType.Buildkite:
            return 'Buildkite';
        case IntegrationType.Bugsnag:
            return 'Bugsnag';
        case IntegrationType.Sentry:
            return 'Sentry';
        case IntegrationType.Jenkins:
            return 'Jenkins';
        case IntegrationType.CircleCI:
            return 'CircleCI';
        case IntegrationType.Amazon:
            return 'Amazon Appstore';
        case IntegrationType.Google:
            return 'Play Console';
        case IntegrationType.GoogleBeta:
            return 'Play Beta Testing';
        case IntegrationType.GitHubVCSDistribution:
            return 'GitHub (public repo)';
        case IntegrationType.GitHubCIDistribution:
            return 'GitHub (action deploy)';
        case IntegrationType.Linear:
            return 'Linear';
        case IntegrationType.TestFlight:
            return 'TestFlight';
        case IntegrationType.TestRail:
            return 'TestRail';
        case IntegrationType.BrowserStack:
            return 'BrowserStack';
        case IntegrationType.Qase:
            return 'Qase';
        case IntegrationType.TravisCI:
            return 'TravisCI';
        case IntegrationType.Firebase:
            return 'Firebase';
        case IntegrationType.Xray:
            return 'Xray';
        case IntegrationType.AppCenterCI:
        case IntegrationType.AppCenterBeta:
            return 'App Center';
        case IntegrationType.Asana:
            return 'Asana';
        case IntegrationType.Amplitude:
            return 'Amplitude';
        case IntegrationType.AzureCI:
            return 'Azure Pipelines';
        case IntegrationType.AzureIT:
            return 'Azure Boards';
        case IntegrationType.MixpanelAnalytics:
            return 'Mixpanel';
        case IntegrationType.DatadogAnalytics:
            return 'Datadog';
        case IntegrationType.GoogleAnalytics:
            return 'Google Analytics';
        case IntegrationType.AndroidVitals:
            return 'Android Vitals';
        case IntegrationType.ApplePowerPerformanceMetrics:
            return 'Apple Power & Performance';
        case IntegrationType.Optimizely:
            return 'Optimizely';
        case IntegrationType.LaunchDarkly:
            return 'LaunchDarkly';
        case IntegrationType.Statsig:
            return 'Statsig';
        case IntegrationType.XcodeCloud:
            return 'Xcode Cloud';
        case IntegrationType.GenericCI:
            return 'CI';
        case IntegrationType.CustomCI:
            return 'Custom CI';
        case IntegrationType.Monday:
            return 'monday.com';
        case IntegrationType.FirebaseBeta:
            return 'Firebase App Distribution';
        case IntegrationType.RunwayBuildDistroBeta:
            return 'Runway Build Distro';
        case IntegrationType.EmbraceStabilityMonitoring:
            return 'Embrace';
        case IntegrationType.AzureVCS:
            return 'Azure Repos';
        case IntegrationType.MicrosoftTeams:
            return 'Teams';
        case IntegrationType.DatadogStabilityMonitoring:
            return 'Datadog';
        case IntegrationType.Crowdin:
            return 'Crowdin';
        case IntegrationType.PagerDutyScheduling:
            return 'PagerDuty';
        case IntegrationType.NewRelicStabilityMonitoring:
            return 'New Relic';
        case IntegrationType.NewRelicAnalytics:
            return 'New Relic';
        case IntegrationType.OpsgenieScheduling:
            return 'Opsgenie';
        case IntegrationType.HuaweiAppGallery:
            return 'Huawei AppGallery';
        case IntegrationType.Samsung:
            return 'Samsung Galaxy Store';
        case IntegrationType.Lokalise:
            return 'Lokalise';
        case IntegrationType.Smartling:
            return 'Smartling';
        case IntegrationType.DynatraceStabilityMonitoring:
            return 'Dynatrace';
        case IntegrationType.CustomAnalytics:
            return 'Custom';
        case IntegrationType.GoogleCalendar:
            return 'Google Calendar';
        case IntegrationType.GooglePersonalCalendar:
            return 'Google Calendar (OAuth)';
        case IntegrationType.JiraServiceManagementScheduling:
            return 'Jira Service Management';
        case IntegrationType.RootlyScheduling:
            return 'Rootly';
        case IntegrationType.IncidentIoScheduling:
            return 'incident.io';
    }
};

export const displayCapabilityForIntegrationType: (integrationType: IntegrationType) => string = (integrationType) => {
    switch (integrationType) {
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCIDistribution:
        case IntegrationType.Google:
        case IntegrationType.Apple:
        case IntegrationType.Amazon:
        case IntegrationType.HuaweiAppGallery:
        case IntegrationType.Samsung:
            return 'Distribution';
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitLabVCS:
        case IntegrationType.Bitbucket:
        case IntegrationType.AzureVCS:
            return 'VCS';
        case IntegrationType.CircleCI:
        case IntegrationType.Jenkins:
        case IntegrationType.Codemagic:
        case IntegrationType.BitbucketCI:
        case IntegrationType.Bitrise:
        case IntegrationType.Buildkite:
        case IntegrationType.GitLabCI:
        case IntegrationType.GitHubCI:
        case IntegrationType.TravisCI:
        case IntegrationType.AppCenterCI:
        case IntegrationType.AzureCI:
        case IntegrationType.XcodeCloud:
        case IntegrationType.GenericCI:
        case IntegrationType.CustomCI:
            return 'CI';
        case IntegrationType.Linear:
        case IntegrationType.Jira:
        case IntegrationType.Pivotal:
        case IntegrationType.Asana:
        case IntegrationType.Shortcut:
        case IntegrationType.AzureIT:
        case IntegrationType.GitHubIT:
            return 'Project management';
        case IntegrationType.Slack:
        case IntegrationType.MicrosoftTeams:
            return 'Comms';
        case IntegrationType.AppCenterBeta:
        case IntegrationType.GoogleBeta:
        case IntegrationType.TestFlight:
        case IntegrationType.FirebaseBeta:
        case IntegrationType.RunwayBuildDistroBeta:
            return 'Beta testing';
        case IntegrationType.Bugsnag:
        case IntegrationType.Sentry:
        case IntegrationType.Firebase:
        case IntegrationType.EmbraceStabilityMonitoring:
        case IntegrationType.DatadogStabilityMonitoring:
        case IntegrationType.NewRelicStabilityMonitoring:
        case IntegrationType.DynatraceStabilityMonitoring:
            return 'Stability monitoring';
        case IntegrationType.TestRail:
        case IntegrationType.Xray:
        case IntegrationType.Qase:
        case IntegrationType.BrowserStack:
            return 'Regression testing';
        case IntegrationType.Amplitude:
        case IntegrationType.MixpanelAnalytics:
        case IntegrationType.DatadogAnalytics:
        case IntegrationType.GoogleAnalytics:
        case IntegrationType.AndroidVitals:
        case IntegrationType.ApplePowerPerformanceMetrics:
        case IntegrationType.NewRelicAnalytics:
        case IntegrationType.CustomAnalytics:
            return 'Observability & analytics';
        case IntegrationType.Optimizely:
        case IntegrationType.LaunchDarkly:
        case IntegrationType.Statsig:
            return 'Feature flagging';
        case IntegrationType.Monday:
            return 'Project management';
        case IntegrationType.Crowdin:
        case IntegrationType.Lokalise:
        case IntegrationType.Smartling:
            return 'Translations';
        case IntegrationType.PagerDutyScheduling:
        case IntegrationType.OpsgenieScheduling:
        case IntegrationType.JiraServiceManagementScheduling:
        case IntegrationType.RootlyScheduling:
        case IntegrationType.IncidentIoScheduling:
            return 'Incident management & scheduling';
        case IntegrationType.GoogleCalendar:
        case IntegrationType.GooglePersonalCalendar:
            return 'Calendar';
    }
};

export const iconAndAltForIntegrationType: (integrationType: IntegrationType) => [string, string] = (
    integrationType,
) => {
    switch (integrationType) {
        case IntegrationType.TestFlight:
            return [testflightLogo, 'TestFlight'];
        case IntegrationType.TestRail:
            return [testRailLogo, 'TestRail'];
        case IntegrationType.BrowserStack:
            return [browserStackLogo, 'BrowserStack'];
        case IntegrationType.Qase:
            return [qaseLogo, 'Qase'];
        case IntegrationType.Apple:
            return [appStoreLogo, 'Apple App Store'];
        case IntegrationType.Bitbucket:
        case IntegrationType.BitbucketCI:
            return [bitbucketLogo, 'Bitbucket'];
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCIDistribution:
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubIT:
            return [githubLogo, 'GitHub'];
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitLabCI:
            return [gitLabLogo, 'GitLab'];
        case IntegrationType.Jira:
            return [jiraLogo, 'Jira'];
        case IntegrationType.Pivotal:
            return [pivotalLogo, 'Pivotal'];
        case IntegrationType.Slack:
            return [slackLogo, 'Slack'];
        case IntegrationType.Codemagic:
            return [codemagicLogo, 'Codemagic'];
        case IntegrationType.Bitrise:
            return [bitriseLogo, 'Bitrise'];
        case IntegrationType.Buildkite:
            return [buildkiteLogo, 'Buildkite'];
        case IntegrationType.Bugsnag:
            return [bugsnagLogo, 'Bugsnag'];
        case IntegrationType.Sentry:
            return [sentryLogo, 'Sentry'];
        case IntegrationType.Jenkins:
            return [jenkinsLogo, 'Jenkins'];
        case IntegrationType.CircleCI:
            return [circleLogo, 'CircleCI'];
        case IntegrationType.GoogleBeta:
            return [googlePlayLogo, 'Play beta testing'];
        case IntegrationType.Google:
            return [googlePlayLogo, 'Google Play Store'];
        case IntegrationType.Amazon:
            return [amazonLogo, 'Amazon Appstore'];
        case IntegrationType.Linear:
            return [linearLogo, 'Linear'];
        case IntegrationType.TravisCI:
            return [travisCILogo, 'TravisCI'];
        case IntegrationType.Firebase:
            return [firebaseCrashlyticsLogo, 'Firebase Crashlytics'];
        case IntegrationType.FirebaseBeta:
            return [firebaseAppDistributionLogo, 'Firebase App Distribution'];
        case IntegrationType.Xray:
            return [xrayLogo, 'Xray'];
        case IntegrationType.AppCenterBeta:
            return [appcenterCILogo, 'App Center beta testing'];
        case IntegrationType.AppCenterCI:
            return [appcenterCILogo, 'App Center'];
        case IntegrationType.Asana:
            return [asanaLogo, 'Asana'];
        case IntegrationType.Shortcut:
            return [shortcutLogo, 'Shortcut'];
        case IntegrationType.Amplitude:
            return [amplitudeLogo, 'Amplitude'];
        case IntegrationType.AzureCI:
            return [azurePipelinesLogo, 'Azure Pipelines'];
        case IntegrationType.AzureIT:
            return [azureBoardsLogo, 'Azure Boards'];
        case IntegrationType.DatadogAnalytics:
        case IntegrationType.DatadogStabilityMonitoring:
            return [datadogLogo, 'Datadog'];
        case IntegrationType.MixpanelAnalytics:
            return [mixpanelLogo, 'Mixpanel'];
        case IntegrationType.GoogleAnalytics:
            return [gaLogo, 'Google Analytics'];
        case IntegrationType.AndroidVitals:
            return [avLogo, 'Android Vitals'];
        case IntegrationType.ApplePowerPerformanceMetrics:
            return [applePowerPerformanceMetricsLogo, 'Apple Power and Performance Metrics'];
        case IntegrationType.Optimizely:
            return [optimizelyLogo, 'Optimizely'];
        case IntegrationType.LaunchDarkly:
            return [launchDarklyLogo, 'LaunchDarkly'];
        case IntegrationType.Statsig:
            return [statsigLogo, 'Statsig'];
        case IntegrationType.XcodeCloud:
            return [xcodeCloudLogo, 'Xcode Cloud'];
        case IntegrationType.GenericCI:
            return [genericCILogo, 'CI'];
        case IntegrationType.Monday:
            return [mondayLogo, 'Monday'];
        case IntegrationType.EmbraceStabilityMonitoring:
            return [embraceLogo, 'Embrace'];
        case IntegrationType.RunwayBuildDistroBeta:
            return [runwayLogo, 'Runway Build Distro'];
        case IntegrationType.AzureVCS:
            return [azureReposLogo, 'Azure Repos'];
        case IntegrationType.MicrosoftTeams:
            return [microsoftTeamsLogo, 'Microsoft Teams'];
        case IntegrationType.Crowdin:
            return [crowdinLogo, 'Crowdin'];
        case IntegrationType.PagerDutyScheduling:
            return [pagerDutyLogo, 'PagerDuty'];
        case IntegrationType.NewRelicStabilityMonitoring:
        case IntegrationType.NewRelicAnalytics:
            return [newRelicLogo, 'New Relic'];
        case IntegrationType.OpsgenieScheduling:
            return [opsgenieLogo, 'Opsgenie'];
        case IntegrationType.HuaweiAppGallery:
            return [huaweiAppGalleryLogo, 'Huawei AppGallery'];
        case IntegrationType.Lokalise:
            return [lokaliseLogo, 'Lokalise'];
        case IntegrationType.Smartling:
            return [smartlingLogo, 'Smartling'];
        case IntegrationType.Samsung:
            return [samsungLogo, 'Samsung Galaxy Store'];
        case IntegrationType.DynatraceStabilityMonitoring:
            return [dynatraceLogo, 'Dynatrace'];
        case IntegrationType.CustomAnalytics:
            return [customIntegrationLogo, 'Custom'];
        case IntegrationType.GoogleCalendar:
            return [googleCalendar, 'Google Calendar'];
        case IntegrationType.GooglePersonalCalendar:
            return [googleCalendar, 'Google Calendar (OAuth)'];
        case IntegrationType.JiraServiceManagementScheduling:
            return [jiraServiceManagementLogo, 'Jira Service Management'];
        case IntegrationType.RootlyScheduling:
            return [rootlyLogo, 'Rootly'];
        case IntegrationType.IncidentIoScheduling:
            return [incidentIoLogo, 'incident.io'];
        default:
            // Custom CI integrationId can have format "custom-ci:{hash}"
            if (integrationType?.includes(IntegrationType.CustomCI)) {
                return [genericCILogo, 'Custom CI'];
            }
            return [null, 'Unknown'];
    }
};

export const isBetaForIntegrationType: (integrationType: IntegrationType) => boolean = (integrationType) => {
    switch (integrationType) {
        default:
            return false;
    }
};

export const providerTypeForIntegrationType: (integrationType: IntegrationType) => IntegrationProviderType = (
    integrationType,
) => {
    switch (integrationType) {
        case IntegrationType.TestFlight:
        case IntegrationType.Apple:
        case IntegrationType.XcodeCloud:
        case IntegrationType.ApplePowerPerformanceMetrics:
            return IntegrationProviderType.Apple;
        case IntegrationType.Bitbucket:
        case IntegrationType.BitbucketCI:
            return IntegrationProviderType.Bitbucket;
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCIDistribution:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubIT:
            return IntegrationProviderType.GitHub;
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitLabCI:
            return IntegrationProviderType.GitLab;
        case IntegrationType.Jira:
            return IntegrationProviderType.Jira;
        case IntegrationType.JiraServiceManagementScheduling:
            return IntegrationProviderType.JiraServiceManagement;
        case IntegrationType.Pivotal:
            return IntegrationProviderType.Pivotal;
        case IntegrationType.Shortcut:
            return IntegrationProviderType.Shortcut;
        case IntegrationType.Slack:
            return IntegrationProviderType.Slack;
        case IntegrationType.Codemagic:
            return IntegrationProviderType.Codemagic;
        case IntegrationType.Bitrise:
            return IntegrationProviderType.Bitrise;
        case IntegrationType.Buildkite:
            return IntegrationProviderType.Buildkite;
        case IntegrationType.Bugsnag:
            return IntegrationProviderType.Bugsnag;
        case IntegrationType.Sentry:
            return IntegrationProviderType.Sentry;
        case IntegrationType.Jenkins:
            return IntegrationProviderType.Jenkins;
        case IntegrationType.CircleCI:
            return IntegrationProviderType.CircleCI;
        case IntegrationType.GoogleBeta:
        case IntegrationType.Google:
        case IntegrationType.Firebase:
        case IntegrationType.FirebaseBeta:
        case IntegrationType.GoogleAnalytics:
        case IntegrationType.AndroidVitals:
        case IntegrationType.GoogleCalendar:
            return IntegrationProviderType.Google;
        case IntegrationType.Amazon:
            return IntegrationProviderType.Amazon;
        case IntegrationType.Linear:
            return IntegrationProviderType.Linear;
        case IntegrationType.TestRail:
            return IntegrationProviderType.TestRail;
        case IntegrationType.BrowserStack:
            return IntegrationProviderType.BrowserStack;
        case IntegrationType.Qase:
            return IntegrationProviderType.Qase;
        case IntegrationType.TravisCI:
            return IntegrationProviderType.TravisCI;
        case IntegrationType.Xray:
            return IntegrationProviderType.Xray;
        case IntegrationType.AppCenterCI:
        case IntegrationType.AppCenterBeta:
            return IntegrationProviderType.AppCenter;
        case IntegrationType.Asana:
            return IntegrationProviderType.Asana;
        case IntegrationType.Amplitude:
            return IntegrationProviderType.Amplitude;
        case IntegrationType.AzureCI:
        case IntegrationType.AzureIT:
        case IntegrationType.AzureVCS:
            return IntegrationProviderType.Azure;
        case IntegrationType.Optimizely:
            return IntegrationProviderType.Optimizely;
        case IntegrationType.LaunchDarkly:
            return IntegrationProviderType.LaunchDarkly;
        case IntegrationType.Statsig:
            return IntegrationProviderType.Statsig;
        case IntegrationType.DatadogAnalytics:
        case IntegrationType.DatadogStabilityMonitoring:
            return IntegrationProviderType.Datadog;
        case IntegrationType.GenericCI:
            return IntegrationProviderType.Generic;
        case IntegrationType.MixpanelAnalytics:
            return IntegrationProviderType.Mixpanel;
        case IntegrationType.Monday:
            return IntegrationProviderType.Monday;
        case IntegrationType.RunwayBuildDistroBeta:
            return IntegrationProviderType.RunwayBuildDistro;
        case IntegrationType.EmbraceStabilityMonitoring:
            return IntegrationProviderType.Embrace;
        case IntegrationType.MicrosoftTeams:
            return IntegrationProviderType.AzureActiveDirectory;
        case IntegrationType.Crowdin:
            return IntegrationProviderType.Crowdin;
        case IntegrationType.PagerDutyScheduling:
            return IntegrationProviderType.PagerDuty;
        case IntegrationType.NewRelicStabilityMonitoring:
        case IntegrationType.NewRelicAnalytics:
            return IntegrationProviderType.NewRelic;
        case IntegrationType.HuaweiAppGallery:
            return IntegrationProviderType.Huawei;
        case IntegrationType.Lokalise:
            return IntegrationProviderType.Lokalise;
        case IntegrationType.Samsung:
            return IntegrationProviderType.Samsung;
        case IntegrationType.OpsgenieScheduling:
            return IntegrationProviderType.Opsgenie;
        case IntegrationType.RootlyScheduling:
            return IntegrationProviderType.Rootly;
        case IntegrationType.IncidentIoScheduling:
            return IntegrationProviderType.IncidentIo;
        case IntegrationType.DynatraceStabilityMonitoring:
            return IntegrationProviderType.Dynatrace;
        case IntegrationType.CustomAnalytics:
            return IntegrationProviderType.CustomAnalytics;
        case IntegrationType.CustomCI:
            return IntegrationProviderType.CustomCI;
        case IntegrationType.GooglePersonalCalendar:
            return IntegrationProviderType.GoogleOAuth;
        default:
            return null;
    }
};

export const displayTextForProviderType: (providerType: IntegrationProviderType) => string = (
    providerType: IntegrationProviderType,
) => {
    switch (providerType) {
        case IntegrationProviderType.Apple:
            return 'Apple';
        case IntegrationProviderType.Azure:
            return 'Azure';
        case IntegrationProviderType.Bitbucket:
            return 'Bitbucket';
        case IntegrationProviderType.Amazon:
            return 'Amazon';
        case IntegrationProviderType.Google:
            return 'Google';
        case IntegrationProviderType.GoogleOAuth:
            return 'Google OAuth';
        case IntegrationProviderType.GitLab:
            return 'GitLab';
        case IntegrationProviderType.GitHub:
            return 'GitHub';
        case IntegrationProviderType.Jira:
            return 'Jira';
        case IntegrationProviderType.Pivotal:
            return 'Pivotal';
        case IntegrationProviderType.Shortcut:
            return 'Shortcut';
        case IntegrationProviderType.Slack:
            return 'Slack';
        case IntegrationProviderType.Jenkins:
            return 'Jenkins';
        case IntegrationProviderType.CircleCI:
            return 'CircleCI';
        case IntegrationProviderType.Codemagic:
            return 'Codemagic';
        case IntegrationProviderType.Bitrise:
            return 'Bitrise';
        case IntegrationProviderType.Buildkite:
            return 'Buildkite';
        case IntegrationProviderType.Linear:
            return 'Linear';
        case IntegrationProviderType.Bugsnag:
            return 'Bugsnag';
        case IntegrationProviderType.Sentry:
            return 'Sentry';
        case IntegrationProviderType.TestRail:
            return 'TestRail';
        case IntegrationProviderType.BrowserStack:
            return 'BrowserStack';
        case IntegrationProviderType.Qase:
            return 'Qase';
        case IntegrationProviderType.TravisCI:
            return 'TravisCI';
        case IntegrationProviderType.Xray:
            return 'Xray';
        case IntegrationProviderType.AppCenter:
            return 'App Center';
        case IntegrationProviderType.Asana:
            return 'Asana';
        case IntegrationProviderType.Amplitude:
            return 'Amplitude';
        case IntegrationProviderType.Optimizely:
            return 'Optimizely';
        case IntegrationProviderType.LaunchDarkly:
            return 'LaunchDarkly';
        case IntegrationProviderType.Datadog:
            return 'Datadog';
        case IntegrationProviderType.Generic:
            return 'Generic Integration';
        case IntegrationProviderType.Mixpanel:
            return 'Mixpanel';
        case IntegrationProviderType.Monday:
            return 'Monday';
        case IntegrationProviderType.RunwayBuildDistro:
            return 'Runway Build Distro';
        case IntegrationProviderType.Embrace:
            return 'Embrace';
        case IntegrationProviderType.AzureActiveDirectory:
            return 'Azure Active Directory';
        case IntegrationProviderType.Crowdin:
            return 'Crowdin';
        case IntegrationProviderType.PagerDuty:
            return 'PagerDuty';
        case IntegrationProviderType.NewRelic:
            return 'New Relic';
        case IntegrationProviderType.Huawei:
            return 'Huawei';
        case IntegrationProviderType.Lokalise:
            return 'Lokalise';
        case IntegrationProviderType.Samsung:
            return 'Samsung';
        case IntegrationProviderType.Opsgenie:
            return 'Opsgenie';
        case IntegrationProviderType.Rootly:
            return 'Rootly';
        case IntegrationProviderType.IncidentIo:
            return 'incident.io';
        case IntegrationProviderType.Dynatrace:
            return 'Dynatrace';
        case IntegrationProviderType.CustomAnalytics:
            return 'Custom';
        case IntegrationProviderType.CustomCI:
            return 'Custom CI';
        case IntegrationProviderType.JiraServiceManagement:
            return 'Jira Service Management';
        default:
            return null;
    }
};

export const iconForProviderType: (providerType: IntegrationProviderType) => string = (
    providerType: IntegrationProviderType,
) => {
    switch (providerType) {
        case IntegrationProviderType.Apple:
            return appStoreLogo;
        case IntegrationProviderType.Azure:
            return azureLogo;
        case IntegrationProviderType.Bitbucket:
            return bitbucketLogo;
        case IntegrationProviderType.Amazon:
            return amazonLogo;
        case IntegrationProviderType.Google:
            return googlePlayLogo;
        case IntegrationProviderType.GitLab:
            return gitLabLogo;
        case IntegrationProviderType.GitHub:
            return githubLogo;
        case IntegrationProviderType.Jira:
            return jiraLogo;
        case IntegrationProviderType.Pivotal:
            return pivotalLogo;
        case IntegrationProviderType.Shortcut:
            return shortcutLogo;
        case IntegrationProviderType.Slack:
            return slackLogo;
        case IntegrationProviderType.Jenkins:
            return jenkinsLogo;
        case IntegrationProviderType.CircleCI:
            return circleLogo;
        case IntegrationProviderType.Codemagic:
            return codemagicLogo;
        case IntegrationProviderType.Bitrise:
            return bitriseLogo;
        case IntegrationProviderType.Buildkite:
            return buildkiteLogo;
        case IntegrationProviderType.Linear:
            return linearLogo;
        case IntegrationProviderType.Bugsnag:
            return bugsnagLogo;
        case IntegrationProviderType.Sentry:
            return sentryLogo;
        case IntegrationProviderType.TestRail:
            return testRailLogo;
        case IntegrationProviderType.BrowserStack:
            return browserStackLogo;
        case IntegrationProviderType.Qase:
            return qaseLogo;
        case IntegrationProviderType.TravisCI:
            return travisCILogo;
        case IntegrationProviderType.Xray:
            return xrayLogo;
        case IntegrationProviderType.AppCenter:
            return appcenterCILogo;
        case IntegrationProviderType.Asana:
            return asanaLogo;
        case IntegrationProviderType.Amplitude:
            return amplitudeLogo;
        case IntegrationProviderType.Optimizely:
            return optimizelyLogo;
        case IntegrationProviderType.LaunchDarkly:
            return launchDarklyLogo;
        case IntegrationProviderType.Statsig:
            return statsigLogo;
        case IntegrationProviderType.Datadog:
            return datadogLogo;
        case IntegrationProviderType.Generic:
            return genericCILogo;
        case IntegrationProviderType.CustomCI:
            return genericCILogo;
        case IntegrationProviderType.CustomAnalytics:
            return customIntegrationLogo;
        case IntegrationProviderType.Mixpanel:
            return mixpanelLogo;
        case IntegrationProviderType.Monday:
            return mondayLogo;
        case IntegrationProviderType.RunwayBuildDistro:
            return runwayLogo;
        case IntegrationProviderType.Embrace:
            return embraceLogo;
        case IntegrationProviderType.AzureActiveDirectory:
            return azureLogo;
        case IntegrationProviderType.Crowdin:
            return crowdinLogo;
        case IntegrationProviderType.PagerDuty:
            return pagerDutyLogo;
        case IntegrationProviderType.NewRelic:
            return newRelicLogo;
        case IntegrationProviderType.Huawei:
            return huaweiAppGalleryLogo;
        case IntegrationProviderType.Lokalise:
            return lokaliseLogo;
        case IntegrationProviderType.Samsung:
            return samsungLogo;
        case IntegrationProviderType.Dynatrace:
            return dynatraceLogo;
        case IntegrationProviderType.JiraServiceManagement:
            return jiraServiceManagementLogo;
        case IntegrationProviderType.Rootly:
            return rootlyLogo;
        case IntegrationProviderType.IncidentIo:
            return incidentIoLogo;
        default:
            return null;
    }
};

export const normalizeFeatureFlagPlatformFilterForApi = (value: unknown): string | undefined => {
    if (value == null || value === '') {
        return undefined;
    }
    if (Array.isArray(value)) {
        const chips = value.map((v) => String(v).trim()).filter((s) => s.length > 0);
        if (chips.length === 0) {
            return undefined;
        }
        const seen = new Set<string>();
        const deduped: string[] = [];
        for (const c of chips) {
            const k = c.toLowerCase();
            if (!seen.has(k)) {
                seen.add(k);
                deduped.push(c);
            }
        }
        return deduped.join(', ');
    }
    if (typeof value === 'string') {
        const t = value.trim();
        return t || undefined;
    }
    return undefined;
};

const normalizeStatsigPlatformFilterSourceForApi = (value: unknown): string | undefined => {
    if (typeof value !== 'string') {
        return undefined;
    }
    const normalized = value.trim().toLowerCase();
    if (normalized === 'rules' || normalized === 'name') {
        return normalized;
    }
    return undefined;
};

const normalizeStatsigPlatformFilterMatchTypeForApi = (value: unknown): string | undefined => {
    if (typeof value !== 'string') {
        return undefined;
    }
    const normalized = value.trim().toLowerCase();
    const validMatches = ['contains', 'starts_with', 'ends_with', 'equals'];
    return validMatches.includes(normalized) ? normalized : undefined;
};

export const validateUpdateIntegrationValues: (
    integrationId: IntegrationType,
    integrationProvider: IntegrationProvider,

    values: any,
) => UpdateIntegrationRequestDataType = (integrationId, integrationProvider, values) => {
    const isBuildVariablesFilteringStrictForPayload =
        values.isBuildVariablesFilteringStrict !== undefined ? values.isBuildVariablesFilteringStrict : null;

    switch (integrationId) {
        case IntegrationType.TestFlight: {
            if (values.bundleId) {
                const provider = integrationProvider as IntegrationProviderApple;
                const appInfo = provider.data.availableApps.find((app) => app.bundleId === values.bundleId);

                return {
                    bundleId: values.bundleId,
                    appleAppId: appInfo?.appId,
                    betaGroupIds: values.selectedBetaGroupIds ?? [],
                };
            }

            return null;
        }
        case IntegrationType.AppCenterBeta: {
            if (values.appId) {
                const provider = integrationProvider as IntegrationProviderAppCenter;
                const appInfo = provider.data.availableApps.find((app) => app.id === values.appId);

                if (appInfo) {
                    return {
                        appId: appInfo.id,
                        betaGroupIds: values.selectedBetaGroupIds ?? [],
                    };
                }
            }

            return null;
        }
        case IntegrationType.Apple: {
            if (values.bundleId) {
                const provider = integrationProvider as IntegrationProviderApple;
                const appInfo = provider.data.availableApps.find((app) => app.bundleId === values.bundleId);

                return {
                    appleAppId: appInfo?.appId,
                    bundleId: values.bundleId,
                };
            }

            return null;
        }
        case IntegrationType.Bitbucket: {
            if (values.workspaceIdAndRepoId) {
                const workspaceId = values.workspaceIdAndRepoId[0];
                const repoId = values.workspaceIdAndRepoId[1];

                if (workspaceId && repoId) {
                    return {
                        orgId: workspaceId,
                        repoName: repoId,
                    };
                }
            }

            return null;
        }
        case IntegrationType.BitbucketCI: {
            if (values.workflowId) {
                const workflowId = values.workflowId;
                const prodWorkflowId = values.prodWorkflowId;
                const devWorkflowId = values.devWorkflowId;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (values.workspaceIdAndRepoId) {
                    const workspaceId = values.workspaceIdAndRepoId[0];
                    const repoId = values.workspaceIdAndRepoId[1];

                    if (workspaceId && repoId) {
                        return {
                            orgId: workspaceId,
                            repoName: repoId,
                            workflowId,
                            prodWorkflowId,
                            devWorkflowId,
                            allowMatchingMultipleAppStoreBuilds,
                            buildVariables,
                        };
                    }
                }
            }

            return null;
        }
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubIT: {
            if (values.repoName) {
                return values;
            }

            return null;
        }
        case IntegrationType.GitHubCI: {
            if (values.repoNameAndWorkflow) {
                const repoName = values.repoNameAndWorkflow[0];
                const workflowId = values.repoNameAndWorkflow[1];
                const prodWorkflowId =
                    values.repoNameAndProdWorkflow ?
                        isEmpty(values.repoNameAndProdWorkflow[1]) ? null
                        :   values.repoNameAndProdWorkflow[1]
                    :   null;
                const devWorkflowId =
                    values.repoNameAndDevWorkflow ?
                        isEmpty(values.repoNameAndDevWorkflow[1]) ? null
                        :   values.repoNameAndDevWorkflow[1]
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (repoName && workflowId) {
                    return {
                        repoName,
                        workflowId,
                        prodWorkflowId,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                        isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                        buildVariables,
                    };
                }
            }

            return null;
        }
        case IntegrationType.GitLabVCS: {
            if (values.projectId) {
                return values;
            }

            return null;
        }
        case IntegrationType.TestRail: {
            if (values.projectId) {
                return values;
            }

            return null;
        }
        case IntegrationType.BrowserStack: {
            if (values.projectId) {
                return values;
            }

            return null;
        }
        case IntegrationType.Qase: {
            if (values.projectId) {
                return values;
            }

            return null;
        }
        case IntegrationType.GitLabCI: {
            if (values.projectId && values.workflowId) {
                const prodWorkflowId =
                    values.prodWorkflowId ?
                        isEmpty(values.prodWorkflowId) ? null
                        :   values.prodWorkflowId
                    :   null;
                const devWorkflowId =
                    values.devWorkflowId ?
                        isEmpty(values.devWorkflowId) ? null
                        :   values.devWorkflowId
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                return {
                    ...values,
                    prodWorkflowId,
                    devWorkflowId,
                    allowMatchingMultipleAppStoreBuilds,
                    isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                    buildVariables,
                };
            }

            return null;
        }
        case IntegrationType.Jira: {
            if (values.projects) {
                return values;
            }

            return null;
        }
        case IntegrationType.Pivotal: {
            if (values.projectIds) {
                return values;
            }

            return null;
        }
        case IntegrationType.Shortcut: {
            if (values.teams) {
                return values;
            }

            return null;
        }
        case IntegrationType.Asana: {
            if (values.projects) {
                return values;
            }

            return null;
        }
        case IntegrationType.Slack: {
            if (values.primaryChannelIds) {
                return values;
            }

            return null;
        }
        case IntegrationType.Codemagic: {
            if (values.slugAndWorkflowId) {
                const appSlug = values.slugAndWorkflowId[0];
                const workflowId = values.slugAndWorkflowId[1];

                let prodAppSlug = null;
                let prodWorkflowId = null;
                if (values.slugAndProdWorkflowId && !isEmpty(values.slugAndProdWorkflowId[1])) {
                    prodAppSlug = values.slugAndProdWorkflowId[0];
                    prodWorkflowId = values.slugAndProdWorkflowId[1];
                }

                let devAppSlug = null;
                let devWorkflowId = null;
                if (values.slugAndDevWorkflowId && !isEmpty(values.slugAndDevWorkflowId[1])) {
                    devAppSlug = values.slugAndDevWorkflowId[0];
                    devWorkflowId = values.slugAndDevWorkflowId[1];
                }

                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (appSlug && workflowId) {
                    return {
                        appSlug,
                        workflowId,
                        prodAppSlug,
                        prodWorkflowId,
                        devAppSlug,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                        isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                        buildVariables,
                    };
                }
            }

            return null;
        }
        case IntegrationType.Bitrise: {
            const isPipeline = parseIsPipelineFromFormValues(values);
            const isStagingPipeline = isPipeline[WorkflowType.Staging] == true;
            const isFormValid =
                (values.slugAndWorkflowId && !isEmpty(values.slugAndWorkflowId[1]) && !isStagingPipeline) ||
                (values.appSlug && values.workflowId && isStagingPipeline);
            if (isFormValid) {
                let appSlug: string;
                let workflowId: string;
                let prodAppSlug = null;
                let prodWorkflowId = null;
                let devAppSlug = null;
                let devWorkflowId = null;

                if (values.slugAndWorkflowId && !isEmpty(values.slugAndWorkflowId[1]) && !isStagingPipeline) {
                    appSlug = values.slugAndWorkflowId[0];
                    workflowId = values.slugAndWorkflowId[1];
                } else if (values.appSlug && values.workflowId && isStagingPipeline) {
                    appSlug = values.appSlug;
                    workflowId = values.workflowId;
                }

                const isProdPipeline = isPipeline[WorkflowType.Production] == true;
                if (values.slugAndProdWorkflowId && !isEmpty(values.slugAndProdWorkflowId[1]) && !isProdPipeline) {
                    prodAppSlug = values.slugAndProdWorkflowId[0];
                    prodWorkflowId = values.slugAndProdWorkflowId[1];
                } else if (values.appSlugProd && values.workflowIdProd && isProdPipeline) {
                    prodAppSlug = values.appSlugProd;
                    prodWorkflowId = values.workflowIdProd;
                }

                const isDevPipeline = isPipeline[WorkflowType.Working] == true;
                if (values.slugAndDevWorkflowId && !isEmpty(values.slugAndDevWorkflowId[1]) && !isDevPipeline) {
                    devAppSlug = values.slugAndDevWorkflowId[0];
                    devWorkflowId = values.slugAndDevWorkflowId[1];
                } else if (values.appSlugDev && values.workflowIdDev && isDevPipeline) {
                    devAppSlug = values.appSlugDev;
                    devWorkflowId = values.workflowIdDev;
                }

                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (appSlug && workflowId) {
                    return {
                        appSlug,
                        workflowId,
                        prodAppSlug,
                        prodWorkflowId,
                        devAppSlug,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                        isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                        buildVariables,
                        isPipeline,
                    };
                }
            }

            return null;
        }
        case IntegrationType.Buildkite: {
            if (values.orgIdAndWorkflowId) {
                const orgId = values.orgIdAndWorkflowId[0];
                const workflowId = values.orgIdAndWorkflowId[1];
                const prodWorkflowId =
                    values.orgIdAndProdWorkflowId ?
                        isEmpty(values.orgIdAndProdWorkflowId[1]) ? null
                        :   values.orgIdAndProdWorkflowId[1]
                    :   null;
                const devWorkflowId =
                    values.orgIdAndDevWorkflowId ?
                        isEmpty(values.orgIdAndDevWorkflowId[1]) ? null
                        :   values.orgIdAndDevWorkflowId[1]
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (orgId && workflowId) {
                    return {
                        orgId,
                        workflowId,
                        prodWorkflowId,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                        isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                        buildVariables,
                    };
                }
            }

            return null;
        }
        case IntegrationType.AzureCI: {
            if (values.projectIdAndWorkflowId) {
                const projectId = values.projectIdAndWorkflowId[0];
                const workflowId = values.projectIdAndWorkflowId[1];
                const prodWorkflowId =
                    values.projectIdAndProdWorkflowId ?
                        isEmpty(values.projectIdAndProdWorkflowId[1]) ? null
                        :   values.projectIdAndProdWorkflowId[1]
                    :   null;
                const devWorkflowId =
                    values.projectIdAndDevWorkflowId ?
                        isEmpty(values.projectIdAndDevWorkflowId[1]) ? null
                        :   values.projectIdAndDevWorkflowId[1]
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                if (projectId && workflowId) {
                    return {
                        projectId,
                        workflowId,
                        prodWorkflowId,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                        isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                        buildVariables,
                    };
                }
            }

            return null;
        }
        case IntegrationType.AzureIT: {
            if (values.projectId) {
                return values;
            }

            return null;
        }

        case IntegrationType.AzureVCS: {
            if (values.projectId && values.repoName) {
                return values;
            }

            return null;
        }

        case IntegrationType.Bugsnag: {
            if (values.orgIdAndProjectId) {
                const orgId = values.orgIdAndProjectId[0];
                const projectId = values.orgIdAndProjectId[1];
                const prodEnvironmentIdentifier =
                    values.orgIdAndProjectIdAndProdStage ?
                        values.orgIdAndProjectIdAndProdStage.length != 3 ?
                            null
                        :   values.orgIdAndProjectIdAndProdStage[2]
                    :   null;

                if (orgId && projectId && prodEnvironmentIdentifier) {
                    const betaEnvironmentIdentifier =
                        values.orgIdAndProjectIdAndBetaStage ?
                            values.orgIdAndProjectIdAndBetaStage.length != 3 ?
                                null
                            :   values.orgIdAndProjectIdAndBetaStage[2]
                        :   null;

                    return {
                        orgId,
                        projectId,
                        prodEnvironmentIdentifier,
                        betaEnvironmentIdentifier,
                    };
                }
            }

            return null;
        }
        case IntegrationType.Sentry: {
            if (values.orgIdAndProjectId) {
                const orgId = values.orgIdAndProjectId[0];
                const projectId = values.orgIdAndProjectId[1];
                const prodEnvironmentIdentifier =
                    values.orgIdAndProjectIdAndProdEnvironment ?
                        values.orgIdAndProjectIdAndProdEnvironment.length != 3 ?
                            null
                        :   values.orgIdAndProjectIdAndProdEnvironment[2]
                    :   null;

                if (orgId && projectId && prodEnvironmentIdentifier) {
                    const betaEnvironmentIdentifier =
                        values.orgIdAndProjectIdAndBetaEnvironment ?
                            values.orgIdAndProjectIdAndBetaEnvironment.length != 3 ?
                                null
                            :   values.orgIdAndProjectIdAndBetaEnvironment[2]
                        :   null;

                    return {
                        orgId,
                        projectId,
                        prodEnvironmentIdentifier,
                        betaEnvironmentIdentifier,
                    };
                }
            }

            return null;
        }
        case IntegrationType.Jenkins: {
            if (values.workflowId) {
                const prodWorkflowId =
                    values.prodWorkflowId ?
                        isEmpty(values.prodWorkflowId) ? null
                        :   values.prodWorkflowId
                    :   null;
                const devWorkflowId =
                    values.devWorkflowId ?
                        isEmpty(values.devWorkflowId) ? null
                        :   values.devWorkflowId
                    :   null;
                const subWorkflowId =
                    values.subWorkflowId ?
                        isEmpty(values.subWorkflowId) ? null
                        :   values.subWorkflowId
                    :   null;
                const devSubWorkflowId =
                    values.devSubWorkflowId ?
                        isEmpty(values.devSubWorkflowId) ? null
                        :   values.devSubWorkflowId
                    :   null;
                const prodSubWorkflowId =
                    values.prodSubWorkflowId ?
                        isEmpty(values.prodSubWorkflowId) ? null
                        :   values.prodSubWorkflowId
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                return {
                    ...values,
                    prodWorkflowId,
                    devWorkflowId,
                    subWorkflowId,
                    prodSubWorkflowId,
                    devSubWorkflowId,
                    allowMatchingMultipleAppStoreBuilds,
                    isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                    buildVariables,
                };
            }
            return null;
        }
        case IntegrationType.CircleCI: {
            if (values.workflowId && values.collaborationId && values.repoName) {
                const definitionId = values.definitionId && !isEmpty(values.definitionId) ? values.definitionId : null;
                const prodWorkflowId =
                    values.prodWorkflowId ?
                        isEmpty(values.prodWorkflowId) ? null
                        :   values.prodWorkflowId
                    :   null;
                const devWorkflowId =
                    values.devWorkflowId ?
                        isEmpty(values.devWorkflowId) ? null
                        :   values.devWorkflowId
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;
                const buildVariables = parseBuildVariablesFromFormValues(values);

                return {
                    ...values,
                    definitionId,
                    prodWorkflowId,
                    devWorkflowId,
                    allowMatchingMultipleAppStoreBuilds,
                    isBuildVariablesFilteringStrict: isBuildVariablesFilteringStrictForPayload,
                    buildVariables,
                };
            }

            return null;
        }
        case IntegrationType.Amazon: {
            if (values.appId) {
                return values;
            }
            return null;
        }
        case IntegrationType.Google: {
            if (values.packageName) {
                return values;
            }

            return null;
        }
        case IntegrationType.HuaweiAppGallery: {
            if (values.appId) {
                return values;
            }
            return null;
        }
        case IntegrationType.Samsung: {
            if (values.contentId) {
                return values;
            }
            return null;
        }
        case IntegrationType.GoogleBeta: {
            if (values.packageName) {
                const testingTrack = values.testingTrack ? sanitizeTrackName(values.testingTrack) : null;

                return {
                    packageName: values.packageName,
                    developerId: values.developerId,
                    testingTrack,
                };
            }

            return null;
        }
        case IntegrationType.FirebaseBeta:
            if (values.projectId && values.firebaseAppId) {
                return {
                    projectId: values.projectId,
                    appId: values.firebaseAppId,
                    betaGroupIds: values.selectedBetaGroupIds,
                };
            }

            return null;
        case IntegrationType.Linear: {
            if (values.teams) {
                return values;
            }

            return null;
        }
        case IntegrationType.TravisCI: {
            if (values.repoName) {
                return values;
            }

            return null;
        }
        case IntegrationType.Firebase: {
            if (values.projectId && values.propertyId) {
                return values;
            }

            return null;
        }
        case IntegrationType.Xray: {
            return values;
        }
        case IntegrationType.AppCenterCI: {
            if (values.appSlug) {
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;

                return {
                    ...values,
                    allowMatchingMultipleAppStoreBuilds,
                };
            }
            return null;
        }
        case IntegrationType.Amplitude: {
            if (values.rawSelectedEventsAndParams?.length < 1) {
                return null;
            }
            return obaaReturnValue(values);
        }

        case IntegrationType.Optimizely: {
            if (values.projectId && values.environmentId) {
                return {
                    ...values,
                    featureFlagPlatformFilter: normalizeFeatureFlagPlatformFilterForApi(
                        values.featureFlagPlatformFilter,
                    ),
                };
            }

            return null;
        }

        case IntegrationType.LaunchDarkly: {
            if (values.projectId && values.environmentId) {
                return values;
            }

            return null;
        }

        case IntegrationType.Statsig: {
            if (values.environmentId) {
                const featureFlagPlatformFilterSource = normalizeStatsigPlatformFilterSourceForApi(
                    values.featureFlagPlatformFilterSource,
                );
                if (values.featureFlagPlatformFilterSource === 'none') {
                    return {
                        ...values,
                        featureFlagPlatformFilter: undefined,
                        featureFlagPlatformFilterSource: undefined,
                        featureFlagPlatformFilterMatchType: undefined,
                    };
                }
                return {
                    ...values,
                    featureFlagPlatformFilter: normalizeFeatureFlagPlatformFilterForApi(
                        values.featureFlagPlatformFilter,
                    ),
                    featureFlagPlatformFilterSource,
                    featureFlagPlatformFilterMatchType:
                        featureFlagPlatformFilterSource === 'rules' ? 'equals' : (
                            normalizeStatsigPlatformFilterMatchTypeForApi(values.featureFlagPlatformFilterMatchType)
                        ),
                };
            }

            return null;
        }

        case IntegrationType.DatadogAnalytics: {
            if (values.rawSelectedEventsAndParams?.length < 1) {
                return null;
            }
            return obaaReturnValue(values);
        }

        case IntegrationType.GenericCI: {
            if (values.workflowId) {
                const prodWorkflowId =
                    values.prodWorkflowId ?
                        isEmpty(values.prodWorkflowId) ? null
                        :   values.prodWorkflowId
                    :   null;
                const devWorkflowId =
                    values.devWorkflowId ?
                        isEmpty(values.devWorkflowId) ? null
                        :   values.devWorkflowId
                    :   null;
                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;

                return {
                    ...values,
                    prodWorkflowId,
                    devWorkflowId,
                    allowMatchingMultipleAppStoreBuilds,
                };
            }

            return null;
        }

        case IntegrationType.CustomCI: {
            const allowMatchingMultipleAppStoreBuilds =
                values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                    values.allowMatchingMultipleAppStoreBuilds
                :   null;

            return {
                allowMatchingMultipleAppStoreBuilds,
            };
        }
        case IntegrationType.MixpanelAnalytics: {
            const mixpanelProjectId = parseInt(values.mixpanelProjectId);
            if (values.rawSelectedEventsAndParams?.length < 1 || isNaN(mixpanelProjectId)) {
                return null;
            }

            if (
                values.useCustomSessionsConfiguration &&
                values.customSessionsEventName &&
                values.customSessionsPropertyName &&
                values.customSessionsPropertyValue &&
                values.customSessionsOperator
            ) {
                values.customSessionsConfiguration = {
                    eventName: values.customSessionsEventName,
                    filteredParameter: {
                        name: values.customSessionsPropertyName,
                        filterValue: values.customSessionsPropertyValue,
                        filterOperator: values.customSessionsOperator,
                    },
                };
            }

            values.mixpanelProjectId = mixpanelProjectId;
            return obaaReturnValue(values);
        }
        case IntegrationType.GoogleAnalytics: {
            if (values.rawSelectedEventsAndParams?.length < 1 || !values.dataStreamId) {
                return null;
            }
            return obaaReturnValue(values);
        }
        case IntegrationType.AndroidVitals: {
            if (values.rawSelectedMetrics?.length > 0 && values.selectedApp) {
                values.rawSelectedEventsAndParams = values.rawSelectedMetrics.map((metric) => {
                    return {
                        ...metric,
                        eventName: metric,
                    };
                });
                return obaaReturnValue(values);
            }
            return null;
        }
        case IntegrationType.ApplePowerPerformanceMetrics: {
            if (values.rawSelectedMetrics?.length > 0) {
                values.rawSelectedEventsAndParams = values.rawSelectedMetrics.map((metric) => {
                    return {
                        ...metric,
                        eventName: metric,
                    };
                });
                return obaaReturnValue(values);
            }
            return null;
        }
        case IntegrationType.XcodeCloud: {
            if (values.productIdAndWorkflowId) {
                const appSlug = values.productIdAndWorkflowId[0];
                const workflowId = values.productIdAndWorkflowId[1];

                let prodAppSlug = null;
                let prodWorkflowId = null;
                if (values.prodProductIdAndWorkflowId && !isEmpty(values.prodProductIdAndWorkflowId[1])) {
                    prodAppSlug = values.prodProductIdAndWorkflowId[0];
                    prodWorkflowId = values.prodProductIdAndWorkflowId[1];
                }

                let devAppSlug = null;
                let devWorkflowId = null;
                if (values.devProductIdAndWorkflowId && !isEmpty(values.devProductIdAndWorkflowId[1])) {
                    devAppSlug = values.devProductIdAndWorkflowId[0];
                    devWorkflowId = values.devProductIdAndWorkflowId[1];
                }

                const allowMatchingMultipleAppStoreBuilds =
                    values.allowMatchingMultipleAppStoreBuilds !== undefined ?
                        values.allowMatchingMultipleAppStoreBuilds
                    :   null;

                if (appSlug && workflowId) {
                    return {
                        appSlug,
                        workflowId,
                        prodAppSlug,
                        prodWorkflowId,
                        devAppSlug,
                        devWorkflowId,
                        allowMatchingMultipleAppStoreBuilds,
                    };
                }
            }

            return null;
        }

        case IntegrationType.Monday: {
            if (values.boardIds && values.faColumns && values.doneColumns) {
                const faColumns = values.faColumns.map((faColumnValues) => {
                    return {
                        boardId: faColumnValues[0],
                        columnId: faColumnValues[1],
                    };
                });

                const doneColumns = values.doneColumns.map((doneColumnValues) => {
                    return {
                        boardId: doneColumnValues[0],
                        columnId: doneColumnValues[1],
                    };
                });

                return {
                    boardIds: values.boardIds,
                    faColumns,
                    doneColumns,
                    additionalDoneStatuses: values.additionalDoneStatuses ?? [],
                };
            }

            return null;
        }

        case IntegrationType.RunwayBuildDistroBeta:
            if (values.bucketId) {
                return {
                    bucketId: values.bucketId,
                };
            }

            return null;
        case IntegrationType.EmbraceStabilityMonitoring: {
            if (values.prodAppSlug) {
                return values;
            }

            return null;
        }

        case IntegrationType.MicrosoftTeams: {
            if (values.primaryChannelIds) {
                return values;
            }

            return null;
        }

        case IntegrationType.DatadogStabilityMonitoring: {
            if (!values.useDatadogServiceMapper) {
                return {
                    ...values,
                    datadogProdServiceValue: '',
                    datadogBetaServiceValue: null,
                };
            }

            return {
                ...values,
                datadogProdServiceValue: values.datadogProdServiceValue ?? '',
                datadogBetaServiceValue: values.datadogBetaServiceValue || null,
                datadogMetricTagFilters: (values.datadogMetricTagFilters ?? []).filter(
                    (filter) => filter?.key?.trim() && filter?.value?.trim(),
                ),
                datadogSingleVersionPerFetch: !!values.datadogSingleVersionPerFetch,
            };
        }

        case IntegrationType.NewRelicStabilityMonitoring: {
            return values;
        }

        case IntegrationType.NewRelicAnalytics: {
            if (values.rawSelectedEventsAndParams?.length < 1) {
                return null;
            }
            return obaaReturnValue(values);
        }

        case IntegrationType.Crowdin: {
            if (values.projectId) {
                const crowdinValues = {
                    ...values,
                    projectId: `${values.projectId}`,
                };
                if (values.metadataProjectId) {
                    crowdinValues.metadataProjectId = `${values.metadataProjectId}`;
                }
                return crowdinValues;
            }

            return null;
        }

        case IntegrationType.Lokalise: {
            if (values.projectId) {
                const lokaliseValues = {
                    ...values,
                    projectId: `${values.projectId}`,
                };
                if (values.metadataProjectId) {
                    lokaliseValues.metadataProjectId = `${values.metadataProjectId}`;
                }
                return lokaliseValues;
            }

            return null;
        }

        case IntegrationType.PagerDutyScheduling:
        case IntegrationType.JiraServiceManagementScheduling:
        case IntegrationType.OpsgenieScheduling:
        case IntegrationType.RootlyScheduling:
        case IntegrationType.IncidentIoScheduling: {
            if (values.scheduleId) {
                return values;
            }
            return null;
        }
        case IntegrationType.DynatraceStabilityMonitoring: {
            return values;
        }
        case IntegrationType.CustomAnalytics:
            return null;
        case IntegrationType.GoogleCalendar:
            return values;
        case IntegrationType.GooglePersonalCalendar:
            return values;
    }
};

const obaaReturnValue = (orig: { rawSelectedEventsAndParams; selectedApp }): { selectedEventsAndParams } => {
    const newValues = {
        ...orig,
        selectedEventsAndParams: orig.rawSelectedEventsAndParams,
        appId: orig.selectedApp,
    };
    delete newValues.rawSelectedEventsAndParams;
    delete newValues.selectedApp;
    return newValues;
};

export const getArgumentsRecordFromArray = (argumentsArray: WorkflowArgument[]): Record<string, string> => {
    if (!argumentsArray) {
        return null;
    }
    const argumentsRecord = {} as Record<string, string>;
    argumentsArray.forEach((argumentPair) => {
        argumentsRecord[argumentPair.argumentKey] = argumentPair.argumentValue;
    });
    return argumentsRecord;
};

export const workflowFieldsFromBucketFormValue = (
    workflowData: string | string[],
): { workflowId: string; appSlug: string | null } => {
    if (Array.isArray(workflowData)) {
        return {
            appSlug: workflowData[0] ?? null,
            workflowId: workflowData[1],
        };
    }

    const parts = workflowData.split(',');
    if (parts.length === 2 && parts[0].trim() && parts[1].trim()) {
        return {
            appSlug: parts[0].trim(),
            workflowId: parts[1].trim(),
        };
    }

    return {
        appSlug: null,
        workflowId: workflowData,
    };
};

const parseBuildVariablesFromFormValues = (values: any): Record<WorkflowType, Record<string, string>> => {
    const buildVariables = {
        [WorkflowType.Staging]: getArgumentsRecordFromArray(values.stagingWorkflowArguments),
        [WorkflowType.Production]: getArgumentsRecordFromArray(values.prodWorkflowArguments),
        [WorkflowType.Working]: getArgumentsRecordFromArray(values.workingWorkflowArguments),
    };
    return buildVariables;
};

export const parseIsPipelineFromFormValues = (values: any): Record<WorkflowType, boolean> => {
    const isPipeline = {
        [WorkflowType.Staging]: values.bitriseIsPipeline,
        [WorkflowType.Production]: values.bitriseIsPipelineProd,
        [WorkflowType.Working]: values.bitriseIsPipelineDev,
    };
    return isPipeline;
};

export const integrationCapabilitiesForPlatform: (platform: AppPlatform, orgId: string) => IntegrationCapability[] = (
    platform,
    _,
) => {
    switch (platform) {
        case AppPlatform.TvOS:
        case AppPlatform.WearOS:
        case AppPlatform.Android:
        case AppPlatform.AndroidTV:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
            return [
                IntegrationCapability.VersionControl,
                IntegrationCapability.FeatureManagement,
                IntegrationCapability.BuildSystem,
                IntegrationCapability.RegressionTesting,
                IntegrationCapability.BetaTesting,
                IntegrationCapability.AppStore,
                IntegrationCapability.Notifications,
                IntegrationCapability.StabilityMonitoring,
                IntegrationCapability.ObservabilityAndAnalytics,
                IntegrationCapability.FeatureFlagging,
                IntegrationCapability.Scheduling,
                IntegrationCapability.Translations,
                IntegrationCapability.Calendar,
            ];
        case AppPlatform.AndroidSDK:
        case AppPlatform.IosSDK:
            return [
                IntegrationCapability.VersionControl,
                IntegrationCapability.FeatureManagement,
                IntegrationCapability.BuildSystem,
                IntegrationCapability.RegressionTesting,
                IntegrationCapability.Notifications,
                IntegrationCapability.StabilityMonitoring,
                IntegrationCapability.ObservabilityAndAnalytics,
                IntegrationCapability.Calendar,
            ];
        case AppPlatform.ReactNativeOTA:
            return [
                IntegrationCapability.VersionControl,
                IntegrationCapability.FeatureManagement,
                IntegrationCapability.BuildSystem,
                IntegrationCapability.RegressionTesting,
                IntegrationCapability.Notifications,
                IntegrationCapability.StabilityMonitoring,
                IntegrationCapability.ObservabilityAndAnalytics,
                IntegrationCapability.Scheduling,
                IntegrationCapability.Calendar,
            ];
        default:
            return [];
    }
};

export const getInvalidIntegration = (appSettings: AppSettings) => {
    return appSettings.integrations.find((integration) => {
        return (
            integration.integrationError &&
            (integration.integrationError?.status === IntegrationErrorType.AuthInvalid ||
                integration.integrationError?.status === IntegrationErrorType.IncorrectData ||
                integration.integrationError?.status === IntegrationErrorType.IncompleteData)
        );
    });
};

export const getConnectionErrorIntegration = (appSettings: AppSettings) => {
    return appSettings.integrations.find((integration) => {
        return (
            integration.integrationError &&
            (integration.integrationError?.status === IntegrationErrorType.Unreachable ||
                integration.integrationError?.status === IntegrationErrorType.InternalError)
        );
    });
};

export const integrationTypeShouldDisableForAppStoreType = (
    integrationType: IntegrationType,
    platform: AppPlatform,
    appStoreType?: AppStoreType,
) => {
    if (!appStoreType) {
        return false;
    }

    if (defaultStoreIntegrationForPlatform(platform) !== integrationType) {
        return false;
    }

    // If the current app store type is not the default for the platform, then we should disable the default integration for the platform (RUN-5515)
    return defaultAppStoreTypeForPlatform(platform) !== appStoreType;
};

export const integrationTypeShouldDisableForPlatform = (integrationType: IntegrationType, appPlatform: AppPlatform) => {
    switch (integrationType) {
        case IntegrationType.GoogleBeta:
        case IntegrationType.Google:
        case IntegrationType.Amazon:
            return getIsApplePlatform(appPlatform);
        case IntegrationType.TestFlight:
        case IntegrationType.Apple:
        case IntegrationType.XcodeCloud:
        case IntegrationType.ApplePowerPerformanceMetrics:
            return isGooglePlatform(appPlatform);
        case IntegrationType.AndroidVitals:
            return !isGooglePlatform(appPlatform);
        default:
            return false;
    }
};

export const appStoreIntegrationTypeForPlatform = (appPlatform: AppPlatform) => {
    switch (appPlatform) {
        case AppPlatform.WearOS:
        case AppPlatform.Android:
        case AppPlatform.AndroidSDK:
            return IntegrationType.Google;
        case AppPlatform.TvOS:
        case AppPlatform.Ios:
        case AppPlatform.VisionOS:
        case AppPlatform.IosSDK:
            return IntegrationType.Apple;
        default:
            return null;
    }
};

export const shouldShowConfigurationDuringOnboarding = (integrationType: IntegrationType) => {
    switch (integrationType) {
        case IntegrationType.GitLabVCS:
        case IntegrationType.GitHubVCS:
        case IntegrationType.Slack:
        case IntegrationType.Linear:
        case IntegrationType.Jira:
        case IntegrationType.Pivotal:
        case IntegrationType.TestRail:
        case IntegrationType.BrowserStack:
        case IntegrationType.Qase:
        case IntegrationType.TestFlight:
        case IntegrationType.GoogleBeta:
        case IntegrationType.AppCenterBeta:
        case IntegrationType.Bugsnag:
        case IntegrationType.Sentry:
        case IntegrationType.Firebase:
        case IntegrationType.Xray:
        case IntegrationType.Asana:
        case IntegrationType.Shortcut:
        case IntegrationType.Bitbucket:
        case IntegrationType.AzureIT:
        case IntegrationType.Optimizely:
        case IntegrationType.Amazon:
        case IntegrationType.LaunchDarkly:
        case IntegrationType.Statsig:
        case IntegrationType.FirebaseBeta:
        case IntegrationType.EmbraceStabilityMonitoring:
        case IntegrationType.AzureVCS:
        case IntegrationType.RunwayBuildDistroBeta:
        case IntegrationType.MicrosoftTeams:
        case IntegrationType.DatadogStabilityMonitoring:
        case IntegrationType.Crowdin:
        case IntegrationType.NewRelicStabilityMonitoring:
        case IntegrationType.NewRelicAnalytics:
        case IntegrationType.Lokalise:
        case IntegrationType.Samsung:
        case IntegrationType.DynatraceStabilityMonitoring:
        case IntegrationType.CustomAnalytics:
        case IntegrationType.GoogleCalendar:
        case IntegrationType.GooglePersonalCalendar:
        case IntegrationType.GitHubIT:
            return true;
        case IntegrationType.GitLabCI:
        case IntegrationType.GitHubCI:
        case IntegrationType.GitHubVCSDistribution:
        case IntegrationType.GitHubCIDistribution:
        case IntegrationType.Jenkins:
        case IntegrationType.CircleCI:
        case IntegrationType.Codemagic:
        case IntegrationType.Bitrise:
        case IntegrationType.Buildkite:
        case IntegrationType.TravisCI:
        case IntegrationType.Apple:
        case IntegrationType.Google:
        case IntegrationType.HuaweiAppGallery:
        case IntegrationType.AppCenterCI:
        case IntegrationType.Amplitude:
        case IntegrationType.AzureCI:
        case IntegrationType.DatadogAnalytics:
        case IntegrationType.GenericCI:
        case IntegrationType.CustomCI:
        case IntegrationType.MixpanelAnalytics:
        case IntegrationType.XcodeCloud:
        case IntegrationType.PagerDutyScheduling:
        case IntegrationType.OpsgenieScheduling:
        case IntegrationType.Monday:
        case IntegrationType.BitbucketCI:
        case IntegrationType.JiraServiceManagementScheduling:
        case IntegrationType.RootlyScheduling:
        case IntegrationType.IncidentIoScheduling:
            return false;
        default:
            return false;
    }
};

export const getAnalyticEventsForIntegration = (integration: Integration): EventAndParam[] => {
    switch (integration.id) {
        case IntegrationType.Amplitude:
            return (integration.data as AmplitudeIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.DatadogAnalytics:
            return (integration.data as DatadogAnalyticsIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.MixpanelAnalytics:
            return (integration.data as MixpanelAnalyticsIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.GoogleAnalytics:
            return (integration.data as GoogleAnalyticsIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.NewRelicAnalytics:
            return (integration.data as NewRelicAnalyticsIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.AndroidVitals:
            return (integration.data as AndroidVitalsIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.ApplePowerPerformanceMetrics:
            return (integration.data as ApplePowerPerformanceIntegrationData)?.selectedEventsAndParams ?? [];
        case IntegrationType.CustomAnalytics:
            return ((integration.data as CustomAnalyticsIntegrationData)?.detectedEvents ?? []).map(
                (eventName: string) => makeEventAndParam(eventName),
            );
        default:
            return [];
    }
};

export const getAnalyticEventNamesForIntegration = (integration: Integration): string[] => {
    return getAnalyticEventsForIntegration(integration).map(eventNameFromEventAndParam) ?? [];
};

/**
 * Mirror of `common.CapabilitySupportsMultipleInstallationsPerStep` in lib/common/integration_capabilities.go.
 * Stability monitoring and observability/analytics can have multiple installations attached to a
 * single FP/WF step config; every other capability is one-installation-per-step.
 *
 * Keep this in sync with the Go-side helper. If the BE list grows, this should too.
 */
export const capabilitySupportsMultipleInstallationsPerStep = (capability: IntegrationCapability): boolean => {
    return (
        capability === IntegrationCapability.StabilityMonitoring ||
        capability === IntegrationCapability.ObservabilityAndAnalytics
    );
};

export const MISSING_REQUIRED_INTEGRATIONS_WARNING = 'One or more required integrations for this step are missing.';

export const stepIsMissingRequiredIntegrations = (step: StepGraphStep): boolean =>
    (step.missingRequiredCapabilities?.length ?? 0) > 0;
